<template>
  <NotFound v-if="typeCheck === 'error'" />
  <main
    class="main-content-area"
    v-else
  >
    <!-- Sticky Top -->

    <div
      class="sticky-review-card"
      id="review-sticky-card"
      v-if="
        !$root.disableNotSupportBanner &&
        pageData &&
        pageData.product_information
      "
    >
      <div
        class="sticky-inner"
        :style="{ '--primary-btn': $root.color_schema.primary_btn }"
      >
        <a
          v-if="
            pageData &&
            pageData.product_id &&
            pageData.product_information &&
            pageData.product_information.product_assets.length > 0
          "
          :title="pageData.product_information.name"
          :href="
            getGoLink(
              pageData.product_information.go_link,
              pageData.product_information.slug
            )
          "
          class="affliate-logo stick-img partner-logo cas-link"
          :rel="
            $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
          "
          target="_blank"
        >
          <template v-if="assets_images && assets_images.pro_asset_sizes">
            <img
              v-if="$root.enable_lazyload"
              v-lazy="
                pageData.product_information.product_assets.filter(
                  (ele) =>
                    ele.asset_category_name ===
                    assets_images.pro_asset_sizes.large
                ).length > 0
                  ? pageData.product_information.product_assets
                      .filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assets_images.pro_asset_sizes.large
                      )
                      .shift().url
                  : $root.site_url + $root.asset_path + '/failure.png'
              "
              height="85"
              width="85"
              :alt="
                getAltText(
                  pageData.product_information.name,
                  pageData.product_information.product_assets.filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assets_images.pro_asset_sizes.large
                  ).length > 0
                    ? pageData.product_information.product_assets
                        .filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assets_images.pro_asset_sizes.large
                        )
                        .shift().url
                    : $root.site_url + $root.asset_path + '/failure.png'
                )
              "
            />
            <img
              v-else
              :src="
                pageData.product_information.product_assets.filter(
                  (ele) =>
                    ele.asset_category_name ===
                    assets_images.pro_asset_sizes.large
                ).length > 0
                  ? pageData.product_information.product_assets
                      .filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assets_images.pro_asset_sizes.large
                      )
                      .shift().url
                  : $root.site_url + $root.asset_path + '/failure.png'
              "
              height="85"
              width="85"
              :alt="
                getAltText(
                  pageData.product_information.name,
                  pageData.product_information.product_assets.filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assets_images.pro_asset_sizes.large
                  ).length > 0
                    ? pageData.product_information.product_assets
                        .filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assets_images.pro_asset_sizes.large
                        )
                        .shift().url
                    : $root.site_url + $root.asset_path + '/failure.png'
                )
              "
            />
            <div class="partner-hover wd-rev-stic">
              <div
                class="partner-hover-inner"
                :style="{
                  '--primary-btn': $root.color_schema.primary_btn,
                  '--primary-btn-hover': pSBC(
                    -0.2,
                    $root.color_schema.primary_btn
                  ),
                }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
            <div
              :class="{
                'stripe-sticky': true,
                'font-dark': getContrastYIQ(
                  Object.keys(hasTag(pageData.product_information.tags))
                    .length > 0
                    ? hasTag(pageData.product_information.tags).color
                    : null
                ),
                'font-light': !getContrastYIQ(
                  Object.keys(hasTag(pageData.product_information.tags))
                    .length > 0
                    ? hasTag(pageData.product_information.tags).color
                    : null
                ),
              }"
              v-if="
                Object.keys(hasTag(pageData.product_information.tags)).length >
                0
              "
              :style="{
                backgroundColor:
                  Object.keys(hasTag(pageData.product_information.tags))
                    .length > 0
                    ? hasTag(pageData.product_information.tags).color
                    : null,
              }"
            >
              <img
                :src="hasTag(pageData.product_information.tags).icon"
                width="18"
                height="12"
                alt="tag-icons"
              />
            </div>
          </template>
          <div class="md-rating rating-wrapper-small">
            <div class="radio-stars">
              <img
                :src="
                  $root.site_url +
                  $root.asset_path +
                  '/svg-icons/yellow-star-big.svg'
                "
                alt="Full Big Star"
              />
            </div>
            <div class="radio-star-total">
              <span>{{
                parseFloat((pageData.product_information.rating / 2).toFixed(1))
              }}</span
              >/5
            </div>
          </div>
        </a>
        <div class="partner-logo affliate-logo" v-else>
          <template
            v-if="
              assets_images &&
              assets_images.pro_asset_sizes &&
              pageData.product_information &&
              pageData.product_information.product_assets.length > 0
            "
          >
            <img
              v-if="$root.enable_lazyload"
              v-lazy="
                pageData.product_information.product_assets
                  .filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assets_images.pro_asset_sizes.large
                  )
                  .shift().url
              "
              height="85"
              width="85"
              :alt="
                getAltText(
                  pageData.product_information.name,
                  pageData.product_information.product_assets
                    .filter(
                      (ele) =>
                        ele.asset_category_name ===
                        assets_images.pro_asset_sizes.large
                    )
                    .shift().url
                )
              "
            />
            <img
              v-else
              :src="
                pageData.product_information.product_assets
                  .filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assets_images.pro_asset_sizes.large
                  )
                  .shift().url
              "
              height="85"
              width="85"
              :alt="
                getAltText(
                  pageData.product_information.name,
                  pageData.product_information.product_assets
                    .filter(
                      (ele) =>
                        ele.asset_category_name ===
                        assets_images.pro_asset_sizes.large
                    )
                    .shift().url
                )
              "
            />
            <div class="partner-hover wd-rev-stic">
              <div
                class="partner-hover-inner"
                :style="{
                  '--primary-btn': $root.color_schema.primary_btn,
                  '--primary-btn-hover': pSBC(
                    -0.2,
                    $root.color_schema.primary_btn
                  ),
                }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
            <div
              :class="{
                'stripe-sticky': true,
                'font-dark': getContrastYIQ(
                  Object.keys(hasTag(pageData.product_information.tags))
                    .length > 0
                    ? hasTag(pageData.product_information.tags).color
                    : null
                ),
                'font-light': !getContrastYIQ(
                  Object.keys(hasTag(pageData.product_information.tags))
                    .length > 0
                    ? hasTag(pageData.product_information.tags).color
                    : null
                ),
              }"
              v-if="
                Object.keys(hasTag(pageData.product_information.tags)).length >
                0
              "
              :style="{
                backgroundColor:
                  Object.keys(hasTag(pageData.product_information.tags))
                    .length > 0
                    ? hasTag(pageData.product_information.tags).color
                    : null,
              }"
            >
              <img
                :src="hasTag(pageData.product_information.tags).icon"
                width="18"
                height="12"
                alt="tag-icons"
              />
            </div>
          </template>
          <div class="md-rating rating-wrapper-small">
            <div class="radio-stars">
              <img
                :src="
                  $root.site_url +
                  $root.asset_path +
                  '/svg-icons/yellow-star-big.svg'
                "
                alt="Full Big Star"
              />
            </div>
            <div class="radio-star-total">
              <span>{{
                parseFloat((pageData.product_information.rating / 2).toFixed(1))
              }}</span
              >/5
            </div>
          </div>
        </div>
        <span class="sticky-text">
          <span class="product-name"
            >{{ pageData.product_information.name }}
            <div
              class="best-rating"
              v-if="
                pageData.product_information &&
                pageData.product_information.rating
              "
            >
              <StarRating
                :rating="
                  parseFloat(
                    (
                      pageData.product_information &&
                      pageData.product_information.rating / 2
                    ).toFixed(1)
                  )
                "
                noText
              /></div
          ></span>

          <span class="sticky-title">
            {{
              getPartnerGlobalString(
                $root.i18n.review,
                pageData.product_information.name
              )
            }}
            <StarRating
              :rating="
                parseFloat(
                  (
                    pageData.product_information &&
                    pageData.product_information.rating / 2
                  ).toFixed(1)
                )
              "
              :classParam="'rev-star'"
            />
          </span>
          <span class="bonus-text" v-if="pageData && pageData.product_id">
            <template v-if="hideBonusLabel">
              <span>{{ $root.i18n.hidden_partner_bonus }}</span>
            </template>
            <template v-else>
              <template v-if="!$root.disable_bonus_cta_on_review">
                <a
                  :title="pageData.product_information.name"
                  :href="
                    getGoLink(
                      pageData.product_information.go_link,
                      pageData.product_information.slug
                    )
                  "
                  class="cas-link"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  v-if="
                    pageData.product_information.bonus_match &&
                    pageData.product_information.exclusive_bonus_amount &&
                    pageData.product_information.exclusive_bonus_match
                  "
                  >{{ pageData.product_information.exclusive_bonus_match }}%
                  {{ $root.i18n.match_bonus_up_to }}
                  {{
                    pageData.product_information.exclusive_bonus_amount
                      | currency(pageData.product_information.bonus_currency)
                  }}</a
                >
                <a
                  :title="pageData.product_information.name"
                  :href="
                    getGoLink(
                      pageData.product_information.go_link,
                      pageData.product_information.slug
                    )
                  "
                  class="cas-link"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  v-if="
                    pageData.product_information.bonus_match &&
                    !pageData.product_information.exclusive_bonus_amount &&
                    pageData.product_information.bonus_amount
                  "
                  >{{ pageData.product_information.bonus_match }}%
                  {{ $root.i18n.match_bonus_up_to }}
                  {{
                    pageData.product_information.bonus_amount
                      | currency(pageData.product_information.bonus_currency)
                  }}</a
                >
                <a
                  :title="pageData.product_information.name"
                  :href="
                    getGoLink(
                      pageData.product_information.go_link,
                      pageData.product_information.slug
                    )
                  "
                  class="cas-link"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  v-if="
                    pageData.product_information.freespin ||
                    pageData.product_information.freebie_name
                  "
                >
                  <template
                    v-if="
                      (pageData.product_information.exclusive_bonus_amount ||
                        pageData.product_information.bonus_amount) &&
                      pageData.product_information.bonus_match
                    "
                    >+</template
                  >
                  <template v-if="pageData.product_information.freespin">
                    <template v-if="pageData.show_freebie_currency === '1'">{{
                      pageData.product_information.freespin
                        | currency(pageData.product_information.bonus_currency)
                    }}</template>
                    <template v-else>{{
                      pageData.product_information.freespin
                    }}</template>
                    {{ pageData.product_information.freebie_name }}
                  </template>
                  <template v-else>{{
                    pageData.product_information.freebie_name
                  }}</template>
                </a>
              </template>
              <template v-else>
                <template
                  v-if="
                    pageData.product_information.bonus_match &&
                    pageData.product_information.exclusive_bonus_amount &&
                    pageData.product_information.exclusive_bonus_match
                  "
                  >{{ pageData.product_information.exclusive_bonus_match }}%
                  {{ $root.i18n.match_bonus_up_to }}
                  {{
                    pageData.product_information.exclusive_bonus_amount
                      | currency(pageData.product_information.bonus_currency)
                  }}</template
                >
                <template
                  v-if="
                    pageData.product_information.bonus_match &&
                    !pageData.product_information.exclusive_bonus_amount &&
                    pageData.product_information.bonus_amount
                  "
                  >{{ pageData.product_information.bonus_match }}%
                  {{ $root.i18n.match_bonus_up_to }}
                  {{
                    pageData.product_information.bonus_amount
                      | currency(pageData.product_information.bonus_currency)
                  }}</template
                >
                <template
                  v-if="
                    pageData.product_information.freespin ||
                    pageData.product_information.freebie_name
                  "
                >
                  <template
                    v-if="
                      (pageData.product_information.exclusive_bonus_amount ||
                        pageData.product_information.bonus_amount) &&
                      pageData.product_information.bonus_match
                    "
                    >+</template
                  >
                  <template v-if="pageData.product_information.freespin">
                    <template v-if="pageData.show_freebie_currency === '1'">{{
                      pageData.product_information.freespin
                        | currency(pageData.product_information.bonus_currency)
                    }}</template>
                    <template v-else>{{
                      pageData.product_information.freespin
                    }}</template>
                    {{ pageData.product_information.freebie_name }}
                  </template>
                  <template v-else>{{
                    pageData.product_information.freebie_name
                  }}</template>
                </template>
              </template>
            </template>
          </span>
          <!-- <template v-else>
            <span class="bonus-text desk-bonus" style="color: red">{{
              $root.i18n.partner_is_not_available_for_your_country
            }}</span>
            <span class="bonus-text mob-bonus" style="color: white">{{
              $root.i18n.partner_is_not_available_for_your_country
            }}</span>
          </template> -->
          <div
            class="terms-conditions desk-terms"
            v-if="
              (pageData.bonus_tc && pageData.bonus_tc != '') ||
              (pageData.terms && pageData.terms != '')
            "
            :style="{ '--primary-btn': $root.color_schema.primary_btn }"
          >
            <span class="cas-term" v-html="pageData.bonus_tc"></span>
            <span
              class="card-stroke"
              v-if="
                pageData.bonus_tc &&
                pageData.terms &&
                pageData.bonus_tc != '' &&
                pageData.terms != ''
              "
              >|</span
            >
            <a
              :rel="
                $root.change_cta_to_sponsored
                  ? 'nofollow sponsored'
                  : 'nofollow'
              "
              class="terms_tc cas-term"
              v-if="pageData.terms && pageData.terms != ''"
              :title="pageData.product_information.name"
              :href="getGoLink(pageData.term_link, pageData.slug)"
              target="_blank"
              >{{ pageData.terms }}</a
            >
          </div>
        </span>
        <a
          v-if="pageData && pageData.product_id"
          :title="pageData.product_information.name"
          :href="
            getGoLink(
              pageData.product_information.go_link,
              pageData.product_information.slug
            )
          "
          :class="{
            'cta cta-primary cta-promotion cta-promo-review custom-btn sticky-play-btn-large hover-btn cas-link': true,
            'text-white':
                        !$root.override_ctabtntxt_color &&
                        !getContrastYIQ($root.color_schema.primary_btn),
                      'text-gray':
                        !$root.override_ctabtntxt_color &&
                        getContrastYIQ($root.color_schema.primary_btn),
                      'text-cta-override': $root.override_ctabtntxt_color,
          }"
          target="_blank"
          :rel="
            $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
          "
          :style="{
            '--primary-btn': $root.color_schema.primary_btn,
            '--primary-btn-hover': pSBC(-0.2, $root.color_schema.primary_btn),
          }"
          ><span class="cta-text">{{
            pageData.product_information.cta_button_text
          }}</span
          ><span
            class="hover-text"
            v-for="(char, indexGo) in $root.i18n.go_to_casino"
            :key="indexGo + `revspp`"
            >{{ char }}</span
          >
          <!--<span
            class="hover-text"
            v-for="(char, indexPro) in pageData.product_information.name.split(
              ''
            )"
            :key="indexPro + `revs`"
            >{{ char }}</span
          >--></a
        >
        <a
          v-if="pageData && pageData.product_id"
          :title="pageData.product_information.name"
          :href="
            getGoLink(
              pageData.product_information.go_link,
              pageData.product_information.slug
            )
          "
          :class="{
            'cta cta-primary cta-promotion cta-promo-review custom-btn-white sticky-play-btn-medium cas-link': true,
            'text-white':
                        !$root.override_ctabtntxt_color &&
                        !getContrastYIQ($root.color_schema.primary_btn),
                      'text-gray':
                        !$root.override_ctabtntxt_color &&
                        getContrastYIQ($root.color_schema.primary_btn),
                      'text-cta-override': $root.override_ctabtntxt_color,
          }"
          target="_blank"
          :rel="
            $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
          "
          :style="{
            '--primary-btn': $root.color_schema.primary_btn,
            '--primary-btn-hover': pSBC(-0.2, $root.color_schema.primary_btn),
          }"
          >{{ pageData.product_information.cta_button_text }}</a
        >
        <div
          class="mob-terms"
          v-if="
            (pageData.bonus_tc && pageData.bonus_tc != '') ||
            (pageData.terms && pageData.terms != '')
          "
        >
          <span
            class="cas-term terms-conditions"
            v-if="pageData.bonus_tc && pageData.bonus_tc != ''"
            v-html="pageData.bonus_tc"
            :style="{ '--primary-btn': $root.color_schema.primary_btn }"
          ></span>
          <span
            class="card-stroke"
            v-if="
              pageData.bonus_tc &&
              pageData.terms &&
              pageData.bonus_tc != '' &&
              pageData.terms != ''
            "
            >|</span
          >
          <a
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
            class="cas-term mob-cas-term"
            v-if="pageData.terms && pageData.terms != ''"
            :title="pageData.product_information.name"
            :href="getGoLink(pageData.term_link, pageData.slug)"
            target="_blank"
            >{{ pageData.terms }}</a
          >
        </div>
        <!--<a
          v-if="pageData && pageData.product_id"
          :href="
            getGoLink(
              pageData.product_information.go_link,
              pageData.product_information.slug
            )
          "
          class="cta cta-promo-review custom-btn-white sticky-play-btn-mobile cas-link"
          :rel="$root.change_cta_to_sponsored ? 'nofollow sponsored':'nofollow'"
          target="_blank"
          >{{
            pageData.product_information.cta_button_text.split(" ").shift()
          }}</a
        >-->
      </div>
    </div>

    <!-- Sticky Top End -->

    <!-- Game banner section -->

    <section
      :class="{
        'ct-inner-banner ct-inner-banner__review pt-26': true,
      }"
      :style="{
        background: $root.color_schema.primary,
      }"
    >
      <div class="container">
        <!--Breadcrumps-->
        <div class="col-md-12">
          <Breadcrumb
              :breadcrumbData="breadCrumb"
              :dark="getContrastYIQ($root.color_schema.primary)"
            />
        </div>
        <!--End Breadcrumps-->

        <div
          class="row"
        >
          <div class="col-md-12">
            <NotSupportModal
              v-if="$root.disableNotSupportBanner"
              :notsupportbannerData="$root.notsupportbannerData"
              :relative="!pageData || !pageData.product_information || Object.keys(pageData).length === 0"
            />
            <div
              :class="{
                'casino-card new-review-banner-card': true,
                'terms-d': pageData.bonus_tc && pageData.bonus_tc != '',
              }"
              v-if="
                pageData &&
                pageData.product_information &&
                Object.keys(pageData).length != 0
              "
            >
              <div class="new-review-banner-card-top">
                <div class="new-review-banner-card-top-left">
                  <div
                    class="review-left-img"
                    v-if="
                      pageData.product_information.product_assets &&
                      pageData.product_information.product_assets.length > 0
                    "
                  >
                    <a
                      v-if="pageData && pageData.product_id"
                      :title="pageData.product_information.name"
                      :href="
                        getGoLink(
                          pageData.product_information.go_link,
                          pageData.product_information.slug
                        )
                      "
                      class="partner-logo cas-link"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                    >
                      <template
                        v-if="assets_images && assets_images.pro_asset_sizes"
                      >
                        <img
                          v-if="$root.enable_lazyload"
                          v-lazy="
                            pageData.product_information.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.large
                            ).length > 0
                              ? pageData.product_information.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.large
                                  )
                                  .shift().url
                              : $root.site_url +
                                $root.asset_path +
                                '/failure.png'
                          "
                          height="250"
                          width="250"
                          :alt="
                            getAltText(
                              pageData.product_information.name,
                              pageData.product_information.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              ).length > 0
                                ? pageData.product_information.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.large
                                    )
                                    .shift().url
                                : $root.site_url +
                                    $root.asset_path +
                                    '/failure.png'
                            )
                          "
                        />
                        <img
                          v-else
                          :src="
                            pageData.product_information.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.large
                            ).length > 0
                              ? pageData.product_information.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.large
                                  )
                                  .shift().url
                              : $root.site_url +
                                $root.asset_path +
                                '/failure.png'
                          "
                          height="250"
                          width="250"
                          :alt="
                            getAltText(
                              pageData.product_information.name,
                              pageData.product_information.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              ).length > 0
                                ? pageData.product_information.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.large
                                    )
                                    .shift().url
                                : $root.site_url +
                                    $root.asset_path +
                                    '/failure.png'
                            )
                          "
                        />
                        <div class="partner-hover wd-rev-bann">
                          <div
                            class="partner-hover-inner"
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                              '--primary-btn-hover': pSBC(
                                -0.2,
                                $root.color_schema.primary_btn
                              ),
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="16"
                              viewBox="0 0 10 16"
                              fill="none"
                            >
                              <path
                                d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                      </template>
                      <span
                        class="exclusive-tag"
                        v-if="
                          Object.keys(hasTag(pageData.product_information.tags))
                            .length > 0
                        "
                        :style="{
                          backgroundColor:
                            Object.keys(
                              hasTag(pageData.product_information.tags)
                            ).length > 0
                              ? hasTag(pageData.product_information.tags).color
                              : null,
                        }"
                      >
                        <p
                          :class="{
                            'desk-excl custom-font-2': true,
                            'text-gray': getContrastYIQ(
                              Object.keys(
                                hasTag(pageData.product_information.tags)
                              ).length > 0
                                ? hasTag(pageData.product_information.tags)
                                    .color
                                : null
                            ),
                            'text-light': !getContrastYIQ(
                              Object.keys(
                                hasTag(pageData.product_information.tags)
                              ).length > 0
                                ? hasTag(pageData.product_information.tags)
                                    .color
                                : null
                            ),
                          }"
                        >
                          <img
                            :src="
                              hasTag(pageData.product_information.tags).icon
                            "
                            width="18"
                            height="12"
                            alt="tag-icons"
                          />
                          {{
                            titleCase(
                              hasTag(pageData.product_information.tags).tag_name
                            )
                          }}
                        </p>
                        <img
                          class="mob-excl"
                          :src="hasTag(pageData.product_information.tags).icon"
                          width="18"
                          height="12"
                          alt="tag-icons"
                        />
                      </span>
                    </a>
                    <template v-else>
                      <template
                        v-if="assets_images && assets_images.pro_asset_sizes"
                      >
                        <img
                          v-if="$root.enable_lazyload"
                          v-lazy="
                            pageData.product_information.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              )
                              .shift().url
                          "
                          height="250"
                          width="250"
                          :alt="
                            getAltText(
                              pageData.product_information.name,
                              pageData.product_information.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.large
                                )
                                .shift().url
                            )
                          "
                        />
                        <img
                          v-else
                          :src="
                            pageData.product_information.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              )
                              .shift().url
                          "
                          height="250"
                          width="250"
                          :alt="
                            getAltText(
                              pageData.product_information.name,
                              pageData.product_information.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.large
                                )
                                .shift().url
                            )
                          "
                        />
                        <div class="partner-hover wd-rev-bann">
                          <div
                            class="partner-hover-inner"
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                              '--primary-btn-hover': pSBC(
                                -0.2,
                                $root.color_schema.primary_btn
                              ),
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="16"
                              viewBox="0 0 10 16"
                              fill="none"
                            >
                              <path
                                d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                      </template>
                      <span
                        class="exclusive-tag"
                        v-if="
                          Object.keys(hasTag(pageData.product_information.tags))
                            .length > 0
                        "
                        :style="{
                          backgroundColor:
                            Object.keys(
                              hasTag(pageData.product_information.tags)
                            ).length > 0
                              ? hasTag(pageData.product_information.tags).color
                              : null,
                        }"
                      >
                        <p
                          :class="{
                            'desk-excl custom-font-2': true,
                            'text-gray': getContrastYIQ(
                              Object.keys(
                                hasTag(pageData.product_information.tags)
                              ).length > 0
                                ? hasTag(pageData.product_information.tags)
                                    .color
                                : null
                            ),
                            'text-light': !getContrastYIQ(
                              Object.keys(
                                hasTag(pageData.product_information.tags)
                              ).length > 0
                                ? hasTag(pageData.product_information.tags)
                                    .color
                                : null
                            ),
                          }"
                        >
                          <img
                            :src="
                              hasTag(pageData.product_information.tags).icon
                            "
                            width="18"
                            height="12"
                            alt="tag-icons"
                          />
                          {{
                            titleCase(
                              hasTag(pageData.product_information.tags).tag_name
                            )
                          }}
                        </p>
                        <img
                          class="mob-excl"
                          :src="hasTag(pageData.product_information.tags).icon"
                          width="18"
                          height="12"
                          alt="tag-icons"
                        />
                      </span>
                    </template>
                  </div>
                  <div class="review-left-content">
                    <!--<span v-if="pageAttr.is_approved" class="approve">
                      <i>
                        <img
                          :src="
                            $root.site_url +
                            $root.asset_path +
                            '/svg-icons/approve-icon.svg'
                          "
                          alt="Approve Icon"
                        />
                      </i>
                      {{ pageAttr.approved_by_expert }}
                    </span>-->
                    <div class="exclusive-bar">
                      <div class="exclusive-bar-title">
                        <div class="trust">
                          <i
                            ><img
                              :src="
                                $root.site_url +
                                $root.asset_path +
                                '/trust-tick.svg'
                              "
                              width="8"
                              height="8"
                              alt="Approve Icon" /></i
                          ><strong>{{
                            pageAttr.is_approved &&
                            pageAttr.approved_by_expert &&
                            pageAttr.approved_by_expert != ""
                              ? pageAttr.approved_by_expert
                              : $root.i18n.trusted_review
                          }}</strong>
                        </div>
                        <p class="custom-font-2">
                          {{ pageData.product_information.name }}
                        </p>
                      </div>
                      <div class="exclusive-bar-rating">
                        <template v-if="pageData.product_information.rating">
                          <StarRating
                            :rating="
                              parseFloat(
                                (
                                  pageData.product_information.rating / 2
                                ).toFixed(1)
                              )
                            "
                          />
                        </template>
                        <span
                          v-if="
                            pageAttr.is_exclusive ||
                            (pageData.product_information
                              .exclusive_bonus_amount &&
                              pageData.product_information
                                .exclusive_bonus_match)
                          "
                          class="exclusive-tag"
                          >{{ $root.i18n.exclusive }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="review-left-content-title"
                      v-if="pageData && pageData.product_id"
                    >
                      <span
                        :class="{
                          'span-h1 cust-span custom-font-1': true,
                          'text-hover': !$root.disable_bonus_cta_on_review,
                        }"
                      >
                        <template v-if="hideBonusLabel">
                          <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                        </template>
                        <template v-else>
                          <template v-if="!$root.disable_bonus_cta_on_review">
                            <a
                              :title="pageData.product_information.name"
                              :href="
                                getGoLink(
                                  pageData.product_information.go_link,
                                  pageData.product_information.slug
                                )
                              "
                              class="cas-link"
                              :rel="
                                $root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'
                              "
                              target="_blank"
                              v-if="
                                pageData.product_information.bonus_match &&
                                pageData.product_information
                                  .exclusive_bonus_amount &&
                                pageData.product_information
                                  .exclusive_bonus_match
                              "
                              >{{
                                pageData.product_information
                                  .exclusive_bonus_match
                              }}% {{ $root.i18n.match_bonus_up_to }}
                              {{
                                pageData.product_information
                                  .exclusive_bonus_amount
                                  | currency(
                                    pageData.product_information.bonus_currency
                                  )
                              }}</a
                            >
                            <a
                              :title="pageData.product_information.name"
                              :href="
                                getGoLink(
                                  pageData.product_information.go_link,
                                  pageData.product_information.slug
                                )
                              "
                              class="cas-link"
                              :rel="
                                $root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'
                              "
                              target="_blank"
                              v-if="
                                pageData.product_information.bonus_match &&
                                !pageData.product_information
                                  .exclusive_bonus_amount &&
                                pageData.product_information.bonus_amount
                              "
                              >{{ pageData.product_information.bonus_match }}%
                              {{ $root.i18n.match_bonus_up_to }}
                              {{
                                pageData.product_information.bonus_amount
                                  | currency(
                                    pageData.product_information.bonus_currency
                                  )
                              }}</a
                            >
                            <a
                              :title="pageData.product_information.name"
                              :href="
                                getGoLink(
                                  pageData.product_information.go_link,
                                  pageData.product_information.slug
                                )
                              "
                              class="cas-link"
                              :rel="
                                $root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'
                              "
                              target="_blank"
                              v-if="
                                pageData.product_information.freespin ||
                                pageData.product_information.freebie_name
                              "
                            >
                              <template
                                v-if="
                                  (pageData.product_information
                                    .exclusive_bonus_amount ||
                                    pageData.product_information
                                      .bonus_amount) &&
                                  pageData.product_information.bonus_match
                                "
                                >+</template
                              >
                              <template
                                v-if="pageData.product_information.freespin"
                              >
                                <template
                                  v-if="pageData.show_freebie_currency === '1'"
                                  >{{
                                    pageData.product_information.freespin
                                      | currency(
                                        pageData.product_information
                                          .bonus_currency
                                      )
                                  }}</template
                                >
                                <template v-else>{{
                                  pageData.product_information.freespin
                                }}</template>
                                {{ pageData.product_information.freebie_name }}
                              </template>
                              <template v-else>{{
                                pageData.product_information.freebie_name
                              }}</template>
                            </a>
                          </template>
                          <template v-else>
                            <template
                              v-if="
                                pageData.product_information.bonus_match &&
                                pageData.product_information
                                  .exclusive_bonus_amount &&
                                pageData.product_information
                                  .exclusive_bonus_match
                              "
                              >{{
                                pageData.product_information
                                  .exclusive_bonus_match
                              }}% {{ $root.i18n.match_bonus_up_to }}
                              {{
                                pageData.product_information
                                  .exclusive_bonus_amount
                                  | currency(
                                    pageData.product_information.bonus_currency
                                  )
                              }}</template
                            >
                            <template
                              v-if="
                                pageData.product_information.bonus_match &&
                                !pageData.product_information
                                  .exclusive_bonus_amount &&
                                pageData.product_information.bonus_amount
                              "
                              >{{ pageData.product_information.bonus_match }}%
                              {{ $root.i18n.match_bonus_up_to }}
                              {{
                                pageData.product_information.bonus_amount
                                  | currency(
                                    pageData.product_information.bonus_currency
                                  )
                              }}</template
                            >
                            <template
                              v-if="
                                pageData.product_information.freespin ||
                                pageData.product_information.freebie_name
                              "
                            >
                              <template
                                v-if="
                                  (pageData.product_information
                                    .exclusive_bonus_amount ||
                                    pageData.product_information
                                      .bonus_amount) &&
                                  pageData.product_information.bonus_match
                                "
                                >+</template
                              >
                              <template
                                v-if="pageData.product_information.freespin"
                              >
                                <template
                                  v-if="pageData.show_freebie_currency === '1'"
                                  >{{
                                    pageData.product_information.freespin
                                      | currency(
                                        pageData.product_information
                                          .bonus_currency
                                      )
                                  }}</template
                                >
                                <template v-else>{{
                                  pageData.product_information.freespin
                                }}</template>
                                {{ pageData.product_information.freebie_name }}
                              </template>
                              <template v-else>{{
                                pageData.product_information.freebie_name
                              }}</template>
                            </template>
                          </template>
                        </template>
                      </span>
                      <template v-if="pageData.product_information.go_link">
                        <a
                          :title="pageData.product_information.name"
                          :href="
                            getGoLink(
                              pageData.product_information.go_link,
                              pageData.product_information.slug
                            )
                          "
                          :class="{
                            'cta cta-primary cta-promotion cta-promo-review ct-btn custom-btn hover-btn cas-link': true,
                            'text-white':
                        !$root.override_ctabtntxt_color &&
                        !getContrastYIQ($root.color_schema.primary_btn),
                      'text-gray':
                        !$root.override_ctabtntxt_color &&
                        getContrastYIQ($root.color_schema.primary_btn),
                      'text-cta-override': $root.override_ctabtntxt_color,
                          }"
                          target="_blank"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                          ><span class="cta-text">{{
                            pageData.product_information.cta_button_text
                          }}</span
                          ><span
                            class="hover-text"
                            v-for="(char, indexGo) in $root.i18n.go_to_casino"
                            :key="indexGo + `revspp`"
                            >{{ char }}</span
                          >
                          <!--<span
                            class="hover-text"
                            v-for="(char,
                            indexPro) in pageData.product_information.name.split(
                              ''
                            )"
                            :key="indexPro + `revs`"
                            >{{ char }}</span
                          >--></a
                        >
                      </template>
                    </div>
                    <!-- <div
                      class="review-left-content-title"
                      style="color: red"
                      v-else
                    >
                      {{ $root.i18n.partner_is_not_available_for_your_country }}
                    </div> -->
                  </div>
                </div>
                <div
                  class="review-left-content-title view-mob"
                  v-if="pageData && pageData.product_id"
                >
                  <span class="span-h1 custom-font-1">
                    <template v-if="hideBonusLabel">
                      <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                    </template>
                    <template v-else>
                      <template v-if="!$root.disable_bonus_cta_on_review">
                        <a
                          :title="pageData.product_information.name"
                          :href="
                            getGoLink(
                              pageData.product_information.go_link,
                              pageData.product_information.slug
                            )
                          "
                          class="cas-link"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          v-if="
                            pageData.product_information.bonus_match &&
                            pageData.product_information
                              .exclusive_bonus_amount &&
                            pageData.product_information.exclusive_bonus_match
                          "
                          >{{
                            pageData.product_information.exclusive_bonus_match
                          }}%
                          {{ $root.i18n.match_bonus_up_to }}
                          {{
                            pageData.product_information.exclusive_bonus_amount
                              | currency(
                                pageData.product_information.bonus_currency
                              )
                          }}</a
                        >
                        <a
                          :title="pageData.product_information.name"
                          :href="
                            getGoLink(
                              pageData.product_information.go_link,
                              pageData.product_information.slug
                            )
                          "
                          class="cas-link"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          v-if="
                            pageData.product_information.bonus_match &&
                            !pageData.product_information
                              .exclusive_bonus_amount &&
                            pageData.product_information.bonus_amount
                          "
                          >{{ pageData.product_information.bonus_match }}%
                          {{ $root.i18n.match_bonus_up_to }}
                          {{
                            pageData.product_information.bonus_amount
                              | currency(
                                pageData.product_information.bonus_currency
                              )
                          }}</a
                        >
                        <a
                          :title="pageData.product_information.name"
                          :href="
                            getGoLink(
                              pageData.product_information.go_link,
                              pageData.product_information.slug
                            )
                          "
                          class="cas-link"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          v-if="
                            pageData.product_information.freespin &&
                            pageData.product_information.freebie_name &&
                            !pageData.product_information
                              .exclusive_bonus_amount &&
                            !pageData.product_information.bonus_amount
                          "
                          >{{ pageData.product_information.freespin }}
                          {{ pageData.product_information.freebie_name }}</a
                        >
                        <a
                          :title="pageData.product_information.name"
                          :href="
                            getGoLink(
                              pageData.product_information.go_link,
                              pageData.product_information.slug
                            )
                          "
                          class="cas-link"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          v-if="
                            pageData.product_information.bonus_amount &&
                            !pageData.product_information.bonus_match &&
                            !pageData.product_information
                              .exclusive_bonus_amount &&
                            !pageData.product_information.freespin &&
                            pageData.product_information.freebie_name
                          "
                          >{{
                            pageData.product_information.bonus_amount
                              | currency(
                                pageData.product_information.bonus_currency
                              )
                          }}
                          {{ pageData.product_information.bonus_name }}</a
                        >
                        <a
                          :title="pageData.product_information.name"
                          :href="
                            getGoLink(
                              pageData.product_information.go_link,
                              pageData.product_information.slug
                            )
                          "
                          class="cas-link"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          v-if="
                            pageData.product_information.freespin ||
                            pageData.product_information.freebie_name
                          "
                        >
                          <template
                            v-if="
                              (pageData.product_information
                                .exclusive_bonus_amount ||
                                pageData.product_information.bonus_amount) &&
                              pageData.product_information.bonus_match
                            "
                            >+</template
                          >
                          <template
                            v-if="pageData.product_information.freespin"
                          >
                            <template
                              v-if="pageData.show_freebie_currency === '1'"
                              >{{
                                pageData.product_information.freespin
                                  | currency(
                                    pageData.product_information.bonus_currency
                                  )
                              }}</template
                            >
                            <template v-else>{{
                              pageData.product_information.freespin
                            }}</template>
                            {{ pageData.product_information.freebie_name }}
                          </template>
                          <template v-else>{{
                            pageData.product_information.freebie_name
                          }}</template>
                        </a>
                      </template>
                      <template v-else>
                        <template
                          v-if="
                            pageData.product_information.bonus_match &&
                            pageData.product_information
                              .exclusive_bonus_amount &&
                            pageData.product_information.exclusive_bonus_match
                          "
                          >{{
                            pageData.product_information.exclusive_bonus_match
                          }}%
                          {{ $root.i18n.match_bonus_up_to }}
                          {{
                            pageData.product_information.exclusive_bonus_amount
                              | currency(
                                pageData.product_information.bonus_currency
                              )
                          }}</template
                        >
                        <template
                          v-if="
                            pageData.product_information.bonus_match &&
                            !pageData.product_information
                              .exclusive_bonus_amount &&
                            pageData.product_information.bonus_amount
                          "
                          >{{ pageData.product_information.bonus_match }}%
                          {{ $root.i18n.match_bonus_up_to }}
                          {{
                            pageData.product_information.bonus_amount
                              | currency(
                                pageData.product_information.bonus_currency
                              )
                          }}</template
                        >
                        <template
                          v-if="
                            pageData.product_information.freespin &&
                            pageData.product_information.freebie_name &&
                            !pageData.product_information
                              .exclusive_bonus_amount &&
                            !pageData.product_information.bonus_amount
                          "
                          >{{ pageData.product_information.freespin }}
                          {{
                            pageData.product_information.freebie_name
                          }}</template
                        >
                        <template
                          v-if="
                            pageData.product_information.bonus_amount &&
                            !pageData.product_information.bonus_match &&
                            !pageData.product_information
                              .exclusive_bonus_amount &&
                            !pageData.product_information.freespin &&
                            pageData.product_information.freebie_name
                          "
                          >{{
                            pageData.product_information.bonus_amount
                              | currency(
                                pageData.product_information.bonus_currency
                              )
                          }}
                          {{
                            pageData.product_information.bonus_name
                          }}</template
                        >
                        <template
                          v-if="
                            pageData.product_information.freespin ||
                            pageData.product_information.freebie_name
                          "
                        >
                          <template
                            v-if="
                              (pageData.product_information
                                .exclusive_bonus_amount ||
                                pageData.product_information.bonus_amount) &&
                              pageData.product_information.bonus_match
                            "
                            >+</template
                          >
                          <template
                            v-if="pageData.product_information.freespin"
                          >
                            <template
                              v-if="pageData.show_freebie_currency === '1'"
                              >{{
                                pageData.product_information.freespin
                                  | currency(
                                    pageData.product_information.bonus_currency
                                  )
                              }}</template
                            >
                            <template v-else>{{
                              pageData.product_information.freespin
                            }}</template>
                            {{ pageData.product_information.freebie_name }}
                          </template>
                          <template v-else>{{
                            pageData.product_information.freebie_name
                          }}</template>
                        </template>
                      </template>
                    </template>
                  </span>
                  <a
                    :title="pageData.product_information.name"
                    :href="
                      getGoLink(
                        pageData.product_information.go_link,
                        pageData.product_information.slug
                      )
                    "
                    :class="{
                      'cta cta-primary cta-promotion cta-promo-review custom-btn hover-btn cas-link': true,
                      'text-white':
                        !$root.override_ctabtntxt_color &&
                        !getContrastYIQ($root.color_schema.primary_btn),
                      'text-gray':
                        !$root.override_ctabtntxt_color &&
                        getContrastYIQ($root.color_schema.primary_btn),
                      'text-cta-override': $root.override_ctabtntxt_color,
                    }"
                    target="_blank"
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    :style="{
                      '--primary-btn': $root.color_schema.primary_btn,
                      '--primary-btn-hover': pSBC(
                        -0.2,
                        $root.color_schema.primary_btn
                      ),
                    }"
                    ><span class="cta-text">{{
                      pageData.product_information.cta_button_text
                    }}</span
                    ><span
                      class="hover-text"
                      v-for="(char, indexGo) in $root.i18n.go_to_casino"
                      :key="indexGo + `revbbpp`"
                      >{{ char }}</span
                    >
                    <!--<span
                      class="hover-text"
                      v-for="(char,
                      indexPro) in pageData.product_information.name.split('')"
                      :key="indexPro + `revbb`"
                      >{{ char }}</span
                    >--></a
                  >
                </div>
                <!-- <div
                  class="review-left-content-title view-mob"
                  style="color: red"
                  v-else
                >
                  {{ $root.i18n.partner_is_not_available_for_your_country }}
                </div> -->

                <div class="new-review-banner-card-top-right">
                  <!-- <h6>Additional Bonus Information</h6>
                  <p>
                      Exclusive regular bonus: €1000 <br />
                      Regular bonus: €400 <br />
                      Match Bonus: 100% <br />
                      Exclusive Match Bonus: 150% <br />
                      Wagering requirement: x35
                  </p>
                  <h6>Bonus Code:</h6>
                  <p>1BET23FAIR</p> -->
                  <div class="overall-rating">
                    <div class="rating-header">
                      <span class="span-h2">{{
                        $root.i18n.overall_rating
                      }}</span>
                      <div
                        class="rating-count"
                        :style="{
                          background: getFinalStarPercentage(
                            parseFloat(
                              (pageData.product_information.rating / 2).toFixed(
                                1
                              )
                            )
                          ),
                        }"
                      >
                        <div class="rating-count-top">
                          <span class="value">{{
                            parseFloat(
                              (pageData.product_information.rating / 2).toFixed(
                                1
                              )
                            )
                          }}</span>
                          <i class="full-star"></i>
                        </div>
                        <span class="comment"
                          >{{
                            getFinalStarPercentageLabel(
                              parseFloat(
                                (
                                  pageData.product_information.rating / 2
                                ).toFixed(1)
                              )
                            )
                          }}!</span
                        >
                      </div>
                    </div>
                    <div
                      class="progress-bar-block"
                      v-if="
                        pageData.rating_data && pageData.rating_data.length > 0
                      "
                    >
                      <div
                        class="bar-row"
                        v-for="(rtn, ind) in pageData.rating_data.filter(
                          (ele, key) => key != 0
                        )"
                        :key="ind"
                      >
                        <div class="label">
                          <p>{{ rtn.criteria_name }}</p>
                          <span
                            >{{ parseFloat((rtn.value / 2).toFixed(1)) }}
                            <i class="full-star"></i
                          ></span>
                        </div>
                        <div class="bar-rail">
                          <div
                            class="progress-indicator"
                            :style="
                              getStarPercentage(
                                parseFloat((rtn.value / 2).toFixed(1))
                              )
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mx-0 new-review-banner-card-bottom">
                  <div class="col-12 col-md-3 px-0 wd-mar">
                    <div
                      class="casino-card-lists"
                      v-if="
                        pageData.software_provider &&
                        pageData.software_provider.length > 0
                      "
                    >
                      <span class="span-caption span-caption-override"
                        >{{ $root.i18n.software_providers }} ({{
                          pageData.software_provider.length
                        }})</span
                      >
                      <ul
                        class="
                          justify-flex-start
                          flex-wrap
                          review-banner-support
                        "
                      >
                        <li
                          v-for="data in pageData.software_provider.slice(0, 4)"
                          :key="data.po_id"
                        >
                          <figure>
                            <img
                              v-if="$root.enable_lazyload"
                              v-lazy="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                            <img
                              v-else
                              :src="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                          </figure>
                        </li>
                        <template
                          v-if="pageData.software_provider.length === 5"
                        >
                          <li
                            v-for="data in pageData.software_provider.slice(4)"
                            :key="data.po_id"
                          >
                            <figure>
                              <img
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </template>
                        <!-- <template
                          v-if="
                            showHideObj.spTop &&
                            pageData.software_provider.length > 4
                          "
                        >
                          <li
                            v-for="data in pageData.software_provider.slice(3)"
                            :key="data.po_id"
                          >
                            <figure>
                              <img
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </template> @click="showHideObj.spTop = true"-->
                        <li
                          v-if="
                            pageData.software_provider.length > 5 &&
                            !showHideObj.spTop
                          "
                        >
                          <a href="#review-casino-card-software">
                            <figure>
                              <span>
                                <i>
                                  <img
                                    :src="
                                      $root.site_url +
                                      $root.asset_path +
                                      '/svg-icons/plus.svg'
                                    "
                                    alt="Plus Icon"
                                  />
                                </i>
                                {{ pageData.software_provider.length - 4 }}
                              </span>
                            </figure>
                          </a>
                        </li>
                        <!-- <li
                          @click="showHideObj.spTop = false"
                          v-if="showHideObj.spTop"
                        >
                          <figure>
                            <span class="minus"></span>
                          </figure>
                        </li> -->
                      </ul>
                    </div>
                  </div>
                  <div class="offset-md-1 col-12 col-md-3 px-0 wd-mar">
                    <div
                      class="casino-card-lists"
                      v-if="
                        pageData.supported_payments &&
                        pageData.supported_payments.length > 0
                      "
                    >
                      <span class="span-caption span-caption-override"
                        >{{ $root.i18n.top_payment_methods }} ({{
                          pageData.supported_payments.length
                        }})</span
                      >
                      <ul
                        class="
                          justify-flex-start
                          flex-wrap
                          review-banner-support
                        "
                      >
                        <li
                          v-for="data in pageData.supported_payments.slice(
                            0,
                            4
                          )"
                          :key="data.po_id"
                        >
                          <figure>
                            <img
                              v-if="$root.enable_lazyload"
                              v-lazy="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                            <img
                              v-else
                              :src="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                          </figure>
                        </li>
                        <template
                          v-if="pageData.supported_payments.length === 5"
                        >
                          <li
                            v-for="data in pageData.supported_payments.slice(4)"
                            :key="data.po_id"
                          >
                            <figure>
                              <img
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </template>
                        <!-- <template
                          v-if="
                            showHideObj.pmTop &&
                            pageData.supported_payments.length > 4
                          "
                        >
                          <li
                            v-for="data in pageData.supported_payments.slice(3)"
                            :key="data.po_id"
                          >
                            <figure>
                              <img
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </template> @click="showHideObj.pmTop = true"-->
                        <li
                          v-if="
                            pageData.supported_payments.length > 5 &&
                            !showHideObj.pmTop
                          "
                        >
                          <a href="#review-casino-card-payment-method">
                            <figure>
                              <span>
                                <i>
                                  <img
                                    :src="
                                      $root.site_url +
                                      $root.asset_path +
                                      '/svg-icons/plus.svg'
                                    "
                                    alt="Plus Icon"
                                  />
                                </i>
                                {{ pageData.supported_payments.length - 4 }}
                              </span>
                            </figure>
                          </a>
                        </li>
                        <!-- <li
                          @click="showHideObj.pmTop = false"
                          v-if="showHideObj.pmTop"
                        >
                          <figure>
                            <span class="minus"></span>
                          </figure>
                        </li> -->
                      </ul>
                    </div>
                  </div>
                  <div class="offset-md-1 col-12 col-md-3 px-0 wd-mar">
                    <div
                      class="casino-card-lists license-right"
                      v-if="
                        pageData.product_licences &&
                        pageData.product_licences.length > 0
                      "
                    >
                      <span class="span-caption span-caption-override">{{
                        $root.i18n.licenced_under
                      }}</span>
                      <ul
                        class="justify-flex-end flex-wrap review-banner-support"
                      >
                        <li
                          v-for="data in pageData.product_licences.slice(0, 4)"
                          :key="data.po_id"
                        >
                          <figure>
                            <img
                              v-if="$root.enable_lazyload"
                              v-lazy="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                            <img
                              v-else
                              :src="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                          </figure>
                        </li>
                        <template v-if="pageData.product_licences.length === 5">
                          <li
                            v-for="data in pageData.product_licences.slice(4)"
                            :key="data.po_id"
                          >
                            <figure>
                              <img
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </template>
                        <!-- <template
                          v-if="
                            showHideObj.liscTop &&
                            pageData.product_licences.length > 4
                          "
                        >
                          <li
                            v-for="data in pageData.product_licences.slice(3)"
                            :key="data.po_id"
                          >
                            <figure>
                              <img
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </template> @click="showHideObj.liscTop = true"-->
                        <li
                          v-if="
                            pageData.product_licences.length > 5 &&
                            !showHideObj.liscTop
                          "
                        >
                          <a href="#review-support-language">
                            <figure>
                              <span>
                                <i>
                                  <img
                                    :src="
                                      $root.site_url +
                                      $root.asset_path +
                                      '/svg-icons/plus.svg'
                                    "
                                    alt="Plus Icon"
                                  />
                                </i>
                                {{ pageData.product_licences.length - 4 }}
                              </span>
                            </figure>
                          </a>
                        </li>
                        <!-- <li
                          @click="showHideObj.liscTop = false"
                          v-if="showHideObj.liscTop"
                        >
                          <figure>
                            <span class="minus"></span>
                          </figure>
                        </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="div-term"
                v-if="pageData.bonus_tc && pageData.bonus_tc != ''"
              >
                <span
                  class="terms_tc cas-term"
                  v-if="pageData.bonus_tc && pageData.bonus_tc != ''"
                  v-html="pageData.bonus_tc"
                  :style="{ '--primary-btn': $root.color_schema.primary_btn }"
                ></span>
                <span
                  class="card-stroke"
                  v-if="
                    pageData.bonus_tc &&
                    pageData.terms &&
                    pageData.bonus_tc != '' &&
                    pageData.terms != ''
                  "
                  >|</span
                >
                <a
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  class="terms_tc cas-term"
                  v-if="pageData.terms && pageData.terms != ''"
                  :title="pageData.product_information.name"
                  :href="getGoLink(pageData.term_link, pageData.slug)"
                  target="_blank"
                  >{{ pageData.terms }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Game banner section -->

    <!-- Editor Section -->

    <section
      class="ct-editor-section pb-25 pb-1"
      v-if="
        pageIndex > 0 &&
        tabData &&
        tabData.filter((ele) => ele.tab_content).length > 0
      "
    >
      <vue-position-sticky
        id="sticky-nav"
        :offsetTop="stickyNavTop"
        sticky-class="sticky"
      >
        <div class="review-top-menu" v-if="showSticky">
          <nav class="scroll-nav">
            <span
              v-for="(data, index) in tabData.filter((ele) => ele.tab_content)"
              :key="index"
              @click="scrollPage(data.tab_key)"
              :class="{
                'scroll-item': true,
                active: activeKey === data.tab_key,
              }"
              >{{ data.tab_title }}</span
            >
          </nav>
        </div>
      </vue-position-sticky>
      <div class="container">
        <div class="editor-content">
          <div
            v-for="(val, index) in tabData.filter((ele) => ele.tab_content)"
            :key="index"
          >
            <div
              :ref="val.tab_key"
              class="sticky-content"
              v-if="val.tab_content"
            >
              <div v-for="(data, key) in val.tab_content" :key="key">
                <template v-if="key === 'content_block'">
                  <div
                    class=""
                    v-for="(data, index) in data"
                    :key="index + '-initial'"
                  >
                    <!--max-cntent-area-->
                    <div
                      class="custm-text tick-div-blue"
                      :style="{
                        '--heading-font': $root.font_family.heading,
                        '--paragraph-font': $root.font_family.paragraph,
                      }"
                      v-html="data"
                    ></div>
                  </div>
                </template>
                <template v-else-if="key === 'content_icon_block'">
                  <ContentIcon
                    :contentIconData="
                      Object.keys(data).length > 0 ? data : false
                    "
                    :partnerInfo="
                      pageData && pageData.product_information
                        ? pageData.product_information
                        : ''
                    "
                    :buttonCheck="
                      pageData && pageData.product_id ? true : false
                    "
                    :templateCheck="'review'"
                  />
                </template>
                <template v-else-if="key === 'featured_promotion'">
                  <PromotionBannerSuggest :promoData="data.promotion" />
                </template>
                <template v-else-if="key === 'comparison_list'">
                  <ComparisonList
                    :comparisonData="data"
                    :partnerProcons="
                      data.hasOwnProperty('enabled_review_partner_procons') &&
                      data.enabled_review_partner_procons
                        ? pageData.procons && pageData.procons.length > 0
                          ? pageData.procons
                          : []
                        : []
                    "
                    :page="
                      data.hasOwnProperty('enabled_review_partner_procons') &&
                      data.enabled_review_partner_procons
                        ? 'partner-review-block'
                        : 'review'
                    "
                  />
                </template>
                <template v-else-if="key === 'bonus_information'">
                  <BonusInformation
                    :hideBonusLabelB="hideBonusLabel"
                    :assetsSize="assets_images"
                    :bonusData="data"
                    :bonusPartnerData="
                      pageData ? pageData.product_information : {}
                    "
                    :bonusPrimaryColour="
                      pageData ? pageData.primary_colour : ''
                    "
                  />
                </template>
                <div
                  class="casino-card casino-card-software"
                  id="review-casino-card-software"
                  v-else-if="key === 'software_provider_block'"
                >
                  <div
                    class="col-lg-6 col-md-6 col-sm-6"
                    v-if="
                      pageData &&
                      pageData.product_information &&
                      pageData.product_information.online_since &&
                      pageData.product_information.online_since != ''
                    "
                  >
                    <div class="developer-card">
                      <div class="card-header">
                        <p class="first-head">
                          <i
                            ><img
                              v-if="$root.enable_lazyload"
                              v-lazy="data.icon"
                              alt="Software Icon" />
                            <img v-else :src="data.icon" alt="Software Icon"
                          /></i>
                          <strong>{{
                            data.software_providers_on_label &&
                            data.software_providers_on_label != ""
                              ? data.software_providers_on_label
                              : $root.i18n.software_providers
                          }}</strong>
                        </p>
                        <p class="second-head">
                          {{
                            data.online_since_label &&
                            data.online_since_label != ""
                              ? data.online_since_label
                              : $root.i18n.online_since
                          }}:
                          <strong>{{
                            pageData && pageData.product_information
                              ? pageData.product_information.online_since
                              : ""
                          }}</strong>
                        </p>
                      </div>
                      <div
                        class="card-body casino-card-lists"
                        v-if="
                          pageData &&
                          pageData.software_provider &&
                          pageData.software_provider.length > 0
                        "
                      >
                        <span class="span-h6"
                          >{{
                            data.software_providers_on_label &&
                            data.software_providers_on_label != ""
                              ? data.software_providers_on_label
                              : $root.i18n.software_providers_on
                          }}
                          {{ pageData.product_name }} ({{
                            pageData.software_provider.length
                          }}):
                        </span>
                        <ul class="justify-flex-start flex-wrap">
                          <li
                            v-for="data in pageData.software_provider"
                            :key="data.software_id"
                          >
                            <figure>
                              <img
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </ul>
                      </div>
                      <div
                        class="card-footer casino-card-lists"
                        v-if="
                          pageData &&
                          pageData.product_licences &&
                          pageData.product_licences.length > 0
                        "
                      >
                        <span
                          >{{ pageData.product_name }}
                          {{
                            data.licensed_under_label &&
                            data.licensed_under_label != ""
                              ? data.licensed_under_label
                              : $root.i18n.licenced_under
                          }}:
                          <i
                            v-for="data in pageData.product_licences"
                            :key="data.po_id"
                          >
                            <img
                              v-if="$root.enable_lazyload"
                              v-lazy="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                            <img
                              v-else
                              :src="data.url"
                              :alt="getAltText(data.name, data.url)"
                            />
                          </i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="
                    casino-card casino-card-software casino-card-payment-method
                  "
                  id="review-casino-card-payment-method"
                  v-else-if="key === 'payment_option_block'"
                >
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="developer-card">
                      <div class="card-header">
                        <p class="first-head">
                          <i
                            ><img
                              v-if="$root.enable_lazyload"
                              v-lazy="data.icon"
                              alt="Payment Icon" />
                            <img v-else :src="data.icon" alt="Payment Icon"
                          /></i>
                          <strong>{{ $root.i18n.payment_informations }}</strong>
                        </p>
                        <p
                          class="second-head"
                          v-if="
                            (pageData && pageData.minimum_deposit) ||
                            (pageData && pageData.minimum_withdraw)
                          "
                        >
                          <template v-if="pageData && pageData.minimum_deposit">
                            {{ $root.i18n.minimum_deposit }}:
                            <strong>{{
                              pageData.minimum_deposit
                                | currency(pageData.bonus_currency)
                            }}</strong>
                            <br />
                          </template>
                          <template v-if="pageData && pageData.minimum_withdraw"
                            >{{ $root.i18n.minimum_withdrawal }}:
                            <strong>{{
                              pageData.minimum_withdraw
                                | currency(pageData.bonus_currency)
                            }}</strong></template
                          >
                        </p>
                      </div>
                      <div class="card-body casino-card-lists">
                        <template
                          v-if="
                            pageData &&
                            pageData.supported_payments.filter(
                              (ele) => ele.deposit === '1'
                            ).length > 0
                          "
                        >
                          <span class="span-h6"
                            >{{
                              data.deposit_methods_label &&
                              data.deposit_methods_label != ""
                                ? data.deposit_methods_label
                                : $root.i18n.deposit_methods
                            }}
                            ({{
                              pageData.supported_payments.filter(
                                (ele) => ele.deposit === "1"
                              ).length
                            }}):
                          </span>
                          <ul class="justify-flex-start flex-wrap">
                            <li
                              v-for="data in pageData.supported_payments.filter(
                                (ele) => ele.deposit === '1'
                              )"
                              :key="data.po_id"
                            >
                              <figure>
                                <img
                                  v-if="$root.enable_lazyload"
                                  v-lazy="data.url"
                                  :alt="getAltText(data.name, data.url)"
                                />
                                <img
                                  v-else
                                  :src="data.url"
                                  :alt="getAltText(data.name, data.url)"
                                />
                              </figure>
                            </li>
                          </ul>
                        </template>
                        <template
                          v-if="
                            pageData &&
                            pageData.supported_payments.filter(
                              (ele) => ele.withdrawal === '1'
                            ).length > 0
                          "
                        >
                          <span class="span-h6 withdrl"
                            >{{
                              data.withdrawal_methods_label &&
                              data.withdrawal_methods_label != ""
                                ? data.withdrawal_methods_label
                                : $root.i18n.withdrawal_methods
                            }}
                            ({{
                              pageData.supported_payments.filter(
                                (ele) => ele.withdrawal === "1"
                              ).length
                            }}):
                          </span>
                          <ul class="justify-flex-start flex-wrap">
                            <li
                              v-for="data in pageData.supported_payments.filter(
                                (ele) => ele.withdrawal === '1'
                              )"
                              :key="data.po_id"
                            >
                              <figure>
                                <img
                                  v-if="$root.enable_lazyload"
                                  v-lazy="data.url"
                                  :alt="getAltText(data.name, data.url)"
                                />
                                <img
                                  v-else
                                  :src="data.url"
                                  :alt="getAltText(data.name, data.url)"
                                />
                              </figure>
                            </li>
                          </ul>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="
                    casino-card casino-card-software casino-card-payment-method
                  "
                  id="review-support-language"
                  v-else-if="key === 'supported_language_and_supports'"
                >
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="developer-card">
                      <div class="card-header">
                        <p class="first-head">
                          <i
                            ><img
                              v-if="$root.enable_lazyload"
                              v-lazy="data.icon"
                              alt="Card Icon" />
                            <img v-else :src="data.icon" alt="Card Icon"
                          /></i>
                          <strong>{{
                            data.supported_languages_label &&
                            data.supported_languages_label != ""
                              ? data.supported_languages_label
                              : $root.i18n.supported_languages
                          }}</strong>
                        </p>
                      </div>
                      <div class="card-body">
                        <div
                          class="casino-card-lang-lists"
                          v-if="supportedLang && supportedLang.length > 0"
                        >
                          <ul class="flex-wrap">
                            <li
                              v-for="(lang, index) in supportedLang"
                              :key="index"
                            >
                              <img
                                :src="`${$root.site_url}${
                                  $root.asset_path
                                }/flag-svg/${lang.toLowerCase()}.svg`"
                                class="lang-flag"
                                :alt="lang"
                              />
                            </li>
                          </ul>
                        </div>
                        <div class="support-links">
                          <p>
                            <i
                              ><svg
                                width="19"
                                height="14"
                                viewBox="0 0 19 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.595 7.10355L19 11.4428V2.5813L12.595 7.10355Z"
                                  fill="#0165F7"
                                />
                                <path
                                  d="M0 2.5813V11.4428L6.40505 7.10355L0 2.5813Z"
                                  fill="#0165F7"
                                />
                                <path
                                  d="M17.8124 -0.00012207H1.18749C0.593747 -0.00012207 0.126171 0.473183 0.0371094 1.08172L9.49995 7.76368L18.9628 1.08172C18.8737 0.473183 18.4062 -0.00012207 17.8124 -0.00012207Z"
                                  fill="#0165F7"
                                />
                                <path
                                  d="M11.5076 7.87471L9.82652 9.05996C9.72632 9.13155 9.61499 9.16337 9.49995 9.16337C9.38492 9.16337 9.27359 9.12757 9.17339 9.05996L7.49235 7.87073L0.0371094 12.9259C0.129882 13.5305 0.597458 13.9998 1.18749 13.9998H17.8124C18.4025 13.9998 18.87 13.5305 18.9628 12.9259L11.5076 7.87471Z"
                                  fill="#0165F7"
                                />
                              </svg>
                            </i>
                            {{ supportEmail }}
                          </p>
                          <p>
                            <i
                              ><svg
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0)">
                                  <path
                                    opacity="0.2"
                                    d="M4.5 8.52929V11.7646C4.5 11.9362 4.56438 12.1008 4.67899 12.2221C4.7936 12.3435 4.94903 12.4116 5.11111 12.4116H12.4764L15.5 14.9999V4.64694C15.5 4.47533 15.4356 4.31074 15.321 4.1894C15.2064 4.06805 15.051 3.99988 14.8889 3.99988H11.8333V7.88223C11.8333 8.05384 11.7689 8.21842 11.6543 8.33977C11.5397 8.46112 11.3843 8.52929 11.2222 8.52929H4.5Z"
                                    fill="#0165F7"
                                  />
                                  <path
                                    d="M16.5 5.11989C16.4996 4.78053 16.3698 4.45518 16.1391 4.21521C15.9084 3.97525 15.5955 3.84027 15.2692 3.83989H12.8078V1.27988C12.8074 0.94052 12.6776 0.615168 12.4469 0.375203C12.2161 0.135239 11.9033 0.000259068 11.577 -0.00012207H1.73078C1.40447 0.000259068 1.09163 0.135239 0.86089 0.375203C0.630155 0.615168 0.500366 0.94052 0.5 1.27988V11.5199C0.499983 11.6408 0.532865 11.7591 0.594842 11.8614C0.656818 11.9636 0.745356 12.0455 0.850213 12.0975C0.95507 12.1496 1.07196 12.1697 1.18736 12.1556C1.30276 12.1415 1.41196 12.0936 1.50231 12.0177L4.19225 9.7559L4.19233 12.1599C4.19269 12.4993 4.32248 12.8246 4.55322 13.0646C4.78395 13.3045 5.09679 13.4395 5.4231 13.4399H12.6222L15.4978 15.8577C15.5882 15.9336 15.6974 15.9814 15.8128 15.9955C15.9281 16.0096 16.045 15.9895 16.1498 15.9374C16.2546 15.8853 16.3432 15.8035 16.4051 15.7013C16.4671 15.5991 16.5 15.4807 16.5 15.3599V5.11989ZM3.77332 8.4623L1.7307 10.1795V1.27988H11.5769V4.47837L11.5768 4.47997L11.5769 4.48149V8.3199H4.16017C4.01933 8.31992 3.88283 8.37018 3.77332 8.4623ZM13.2267 12.3023C13.1172 12.2102 12.9806 12.1599 12.8398 12.1599H5.4231L5.42302 9.5999H11.577C11.9033 9.59952 12.2161 9.46454 12.4469 9.22458C12.6776 8.98461 12.8074 8.65926 12.8078 8.3199V5.11989H15.2692L15.2693 14.0196L13.2267 12.3023Z"
                                    fill="#0165F7"
                                  />
                                  <path
                                    d="M12 0.999878H1.5L1 9.99988L2 10.4999L2.5 9.99988L4.5 8.99988L12 8.49988V0.999878Z"
                                    fill="#0165F7"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0">
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="white"
                                      transform="translate(0.5 -0.00012207)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </i>
                            {{
                              data.live_chat_available_label &&
                              data.live_chat_available_label != ""
                                ? data.live_chat_available_label
                                : $root.i18n
                                    .twentyfourbyseven_live_chat_available
                            }}
                          </p>
                          <p>
                            <i
                              ><svg
                                width="14"
                                height="16"
                                viewBox="0 0 14 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.6005 11.0995L10.538 9.6932C10.4072 9.63347 10.2618 9.62088 10.1237 9.65734C9.98562 9.6938 9.86232 9.77733 9.77238 9.89535L8.41613 11.6707C6.28762 10.5955 4.57467 8.76018 3.57109 6.47963L5.22813 5.02651C5.33851 4.93032 5.41663 4.79822 5.45067 4.65021C5.48472 4.50219 5.47283 4.34632 5.4168 4.2062L4.1043 0.924954C4.0428 0.773902 3.93405 0.650573 3.79678 0.576233C3.65951 0.501893 3.50233 0.481202 3.35234 0.517727L0.508594 1.22085C0.363992 1.25663 0.234977 1.34386 0.142607 1.46832C0.0502374 1.59277 -3.33104e-05 1.7471 1.65599e-08 1.9061C1.65599e-08 9.42074 5.68477 15.4998 12.6875 15.4998C12.836 15.4999 12.9801 15.4461 13.0963 15.3471C13.2125 15.2482 13.2939 15.1099 13.3273 14.9549L13.9836 11.908C14.0175 11.7466 13.9977 11.5775 13.9278 11.4299C13.8579 11.2823 13.7422 11.1655 13.6005 11.0995Z"
                                  fill="#0165F7"
                                />
                              </svg>
                            </i>
                            <template v-if="contactNumber">
                              {{ contactName }}
                              <br />
                              {{ contactNumber }}
                            </template>
                            <template v-if="!contactNumber">
                              {{
                                data.phone_is_not_available_label &&
                                data.phone_is_not_available_label != ""
                                  ? data.phone_is_not_available_label
                                  : $root.i18n.phone_is_not_available
                              }}
                            </template>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Editor Section Ends -->

    <section class="ct-editor-section pb-25 pb-1" v-if="pageIndex > 2">
      <div class="container">
        <template
          v-if="
            pageData &&
            pageData.product_information &&
            Object.keys(pageData).length != 0
          "
        >
          <div
            :class="{
              'casino-card casino-card-software casino-card-software-recomend casino-card-bonus': true,
              'rm-border':
                (pageData.bonus_tc && pageData.bonus_tc != '') ||
                (pageData.terms && pageData.terms != ''),
            }"
          >
            <div
              class="bonus-card-logo"
              v-if="
                pageData.product_information.product_assets &&
                pageData.product_information.product_assets.length > 0
              "
            >
              <a
                v-if="pageData && pageData.product_id"
                :title="pageData.product_information.name"
                :href="
                  getGoLink(
                    pageData.product_information.go_link,
                    pageData.product_information.slug
                  )
                "
                class="h-100 w-100 partner-logo cas-link"
                :rel="
                  $root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'
                "
                target="_blank"
              >
                <template v-if="assets_images && assets_images.pro_asset_sizes">
                  <img
                    v-if="$root.enable_lazyload"
                    v-lazy="
                      pageData.product_information.product_assets.filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assets_images.pro_asset_sizes.large
                      ).length > 0
                        ? pageData.product_information.product_assets
                            .filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.large
                            )
                            .shift().url
                        : $root.site_url + $root.asset_path + '/failure.png'
                    "
                    :class="{
                      'no-terms':
                        (pageData.bonus_tc && pageData.bonus_tc != '') ||
                        (pageData.terms && pageData.terms != ''),
                    }"
                    width="300"
                    height="320"
                    :alt="
                      getAltText(
                        pageData.product_information.name,
                        pageData.product_information.product_assets.filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assets_images.pro_asset_sizes.large
                        ).length > 0
                          ? pageData.product_information.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              )
                              .shift().url
                          : $root.site_url + $root.asset_path + '/failure.png'
                      )
                    "
                  />
                  <img
                    v-else
                    :src="
                      pageData.product_information.product_assets.filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assets_images.pro_asset_sizes.large
                      ).length > 0
                        ? pageData.product_information.product_assets
                            .filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.large
                            )
                            .shift().url
                        : $root.site_url + $root.asset_path + '/failure.png'
                    "
                    :class="{
                      'no-terms':
                        (pageData.bonus_tc && pageData.bonus_tc != '') ||
                        (pageData.terms && pageData.terms != ''),
                    }"
                    width="300"
                    height="320"
                    :alt="
                      getAltText(
                        pageData.product_information.name,
                        pageData.product_information.product_assets.filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assets_images.pro_asset_sizes.large
                        ).length > 0
                          ? pageData.product_information.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              )
                              .shift().url
                          : $root.site_url + $root.asset_path + '/failure.png'
                      )
                    "
                  />
                  <div class="partner-hover wd-rev-end">
                    <div
                      class="partner-hover-inner"
                      :style="{
                        '--primary-btn': $root.color_schema.primary_btn,
                        '--primary-btn-hover': pSBC(
                          -0.2,
                          $root.color_schema.primary_btn
                        ),
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="16"
                        viewBox="0 0 10 16"
                        fill="none"
                      >
                        <path
                          d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                  <span
                    class="exclusive-tag-rev"
                    v-if="
                      Object.keys(hasTag(pageData.product_information.tags))
                        .length > 0
                    "
                    :style="{
                      backgroundColor:
                        Object.keys(hasTag(pageData.product_information.tags))
                          .length > 0
                          ? hasTag(pageData.product_information.tags).color
                          : null,
                    }"
                  >
                    <p
                      :class="{
                        'custom-font-2': true,
                        'text-gray': getContrastYIQ(
                          Object.keys(hasTag(pageData.product_information.tags))
                            .length > 0
                            ? hasTag(pageData.product_information.tags).color
                            : null
                        ),
                        'text-light': !getContrastYIQ(
                          Object.keys(hasTag(pageData.product_information.tags))
                            .length > 0
                            ? hasTag(pageData.product_information.tags).color
                            : null
                        ),
                      }"
                    >
                      <img
                        :src="hasTag(pageData.product_information.tags).icon"
                        width="18"
                        height="12"
                        alt="tag-icons"
                      />
                      {{
                        titleCase(
                          hasTag(pageData.product_information.tags).tag_name
                        )
                      }}
                    </p>
                  </span>
                </template>
              </a>
              <template v-else>
                <template v-if="assets_images && assets_images.pro_asset_sizes">
                  <img
                    v-if="$root.enable_lazyload"
                    v-lazy="
                      pageData.product_information.product_assets
                        .filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assets_images.pro_asset_sizes.large
                        )
                        .shift().url
                    "
                    :class="{
                      'no-terms':
                        (pageData.bonus_tc && pageData.bonus_tc != '') ||
                        (pageData.terms && pageData.terms != ''),
                    }"
                    width="300"
                    height="320"
                    :alt="
                      getAltText(
                        pageData.product_information.name,
                        pageData.product_information.product_assets
                          .filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assets_images.pro_asset_sizes.large
                          )
                          .shift().url
                      )
                    "
                  />
                  <img
                    v-else
                    :src="
                      pageData.product_information.product_assets
                        .filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assets_images.pro_asset_sizes.large
                        )
                        .shift().url
                    "
                    :class="{
                      'no-terms':
                        (pageData.bonus_tc && pageData.bonus_tc != '') ||
                        (pageData.terms && pageData.terms != ''),
                    }"
                    width="300"
                    height="320"
                    :alt="
                      getAltText(
                        pageData.product_information.name,
                        pageData.product_information.product_assets
                          .filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assets_images.pro_asset_sizes.large
                          )
                          .shift().url
                      )
                    "
                  />
                  <div class="partner-hover wd-rev-end">
                    <div
                      class="partner-hover-inner"
                      :style="{
                        '--primary-btn': $root.color_schema.primary_btn,
                        '--primary-btn-hover': pSBC(
                          -0.2,
                          $root.color_schema.primary_btn
                        ),
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="16"
                        viewBox="0 0 10 16"
                        fill="none"
                      >
                        <path
                          d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                  <span
                    class="exclusive-tag-rev"
                    v-if="
                      Object.keys(hasTag(pageData.product_information.tags))
                        .length > 0
                    "
                    :style="{
                      backgroundColor:
                        Object.keys(hasTag(pageData.product_information.tags))
                          .length > 0
                          ? hasTag(pageData.product_information.tags).color
                          : null,
                    }"
                  >
                    <p
                      :class="{
                        'custom-font-2': true,
                        'text-gray': getContrastYIQ(
                          Object.keys(hasTag(pageData.product_information.tags))
                            .length > 0
                            ? hasTag(pageData.product_information.tags).color
                            : null
                        ),
                        'text-light': !getContrastYIQ(
                          Object.keys(hasTag(pageData.product_information.tags))
                            .length > 0
                            ? hasTag(pageData.product_information.tags).color
                            : null
                        ),
                      }"
                    >
                      <img
                        :src="hasTag(pageData.product_information.tags).icon"
                        width="18"
                        height="12"
                        alt="tag-icons"
                      />
                      {{
                        titleCase(
                          hasTag(pageData.product_information.tags).tag_name
                        )
                      }}
                    </p>
                  </span>
                </template>
              </template>
            </div>
            <div class="bonus-card-content">
              <div class="bonus-card-content-top">
                <div class="half-column">
                  <div class="half-column-cont">
                    <div class="bonus-card-rating">
                      <p class="custom-font-2">
                        {{ pageData.product_information.name }}
                      </p>
                      <!--<div class="rating-wrapper-small desk-ra-excl">
                        <div class="radio-stars">
                          <img
                            :src="
                              $root.site_url +
                              $root.asset_path +
                              '/svg-icons/yellow-star-big.svg'
                            "
                            alt="Full Big Star"
                          />
                        </div>
                        <div class="radio-star-total">
                          <span>{{
                            parseFloat(
                              (pageData.product_information.rating / 2).toFixed(
                                1
                              )
                            )
                          }}</span
                          >/5
                        </div>
                      </div>-->
                      <div
                        class="best-rating"
                        v-if="
                          pageData.product_information &&
                          pageData.product_information.rating
                        "
                      >
                        <StarRating
                          :rating="
                            parseFloat(
                              (
                                pageData.product_information &&
                                pageData.product_information.rating / 2
                              ).toFixed(1)
                            )
                          "
                        />
                      </div>
                    </div>
                    <span
                      class="custom-font-1"
                      v-if="pageData && pageData.product_id"
                    >
                      <template v-if="hideBonusLabel">
                        <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                      </template>
                      <template v-else>
                        <template v-if="!$root.disable_bonus_cta_on_review">
                          <a
                            :title="pageData.product_information.name"
                            :href="
                              getGoLink(
                                pageData.product_information.go_link,
                                pageData.product_information.slug
                              )
                            "
                            class="cas-link"
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                            target="_blank"
                            v-if="
                              pageData.product_information.bonus_match &&
                              pageData.product_information
                                .exclusive_bonus_amount &&
                              pageData.product_information.exclusive_bonus_match
                            "
                            >{{
                              pageData.product_information
                                .exclusive_bonus_match
                            }}% {{ $root.i18n.match_bonus_up_to }}
                            {{
                              pageData.product_information
                                .exclusive_bonus_amount
                                | currency(
                                  pageData.product_information.bonus_currency
                                )
                            }}</a
                          >
                          <a
                            :title="pageData.product_information.name"
                            :href="
                              getGoLink(
                                pageData.product_information.go_link,
                                pageData.product_information.slug
                              )
                            "
                            class="cas-link"
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                            target="_blank"
                            v-if="
                              pageData.product_information.bonus_match &&
                              !pageData.product_information
                                .exclusive_bonus_amount &&
                              pageData.product_information.bonus_amount
                            "
                            >{{ pageData.product_information.bonus_match }}%
                            {{ $root.i18n.match_bonus_up_to }}
                            {{
                              pageData.product_information.bonus_amount
                                | currency(
                                  pageData.product_information.bonus_currency
                                )
                            }}</a
                          >
                          <a
                            :title="pageData.product_information.name"
                            :href="
                              getGoLink(
                                pageData.product_information.go_link,
                                pageData.product_information.slug
                              )
                            "
                            class="cas-link"
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                            target="_blank"
                            v-if="
                              pageData.product_information.freespin ||
                              pageData.product_information.freebie_name
                            "
                          >
                            <template
                              v-if="
                                (pageData.product_information
                                  .exclusive_bonus_amount ||
                                  pageData.product_information.bonus_amount) &&
                                pageData.product_information.bonus_match
                              "
                              >+</template
                            >
                            <template
                              v-if="pageData.product_information.freespin"
                            >
                              <template
                                v-if="pageData.show_freebie_currency === '1'"
                                >{{
                                  pageData.product_information.freespin
                                    | currency(
                                      pageData.product_information
                                        .bonus_currency
                                    )
                                }}</template
                              >
                              <template v-else>{{
                                pageData.product_information.freespin
                              }}</template>
                              {{ pageData.product_information.freebie_name }}
                            </template>
                            <template v-else>{{
                              pageData.product_information.freebie_name
                            }}</template>
                          </a>
                        </template>
                        <template v-else>
                          <template
                            v-if="
                              pageData.product_information.bonus_match &&
                              pageData.product_information
                                .exclusive_bonus_amount &&
                              pageData.product_information.exclusive_bonus_match
                            "
                            >{{
                              pageData.product_information
                                .exclusive_bonus_match
                            }}% {{ $root.i18n.match_bonus_up_to }}
                            {{
                              pageData.product_information
                                .exclusive_bonus_amount
                                | currency(
                                  pageData.product_information.bonus_currency
                                )
                            }}</template
                          >
                          <template
                            v-if="
                              pageData.product_information.bonus_match &&
                              !pageData.product_information
                                .exclusive_bonus_amount &&
                              pageData.product_information.bonus_amount
                            "
                            >{{ pageData.product_information.bonus_match }}%
                            {{ $root.i18n.match_bonus_up_to }}
                            {{
                              pageData.product_information.bonus_amount
                                | currency(
                                  pageData.product_information.bonus_currency
                                )
                            }}</template
                          >
                          <template
                            v-if="
                              pageData.product_information.freespin ||
                              pageData.product_information.freebie_name
                            "
                          >
                            <template
                              v-if="
                                (pageData.product_information
                                  .exclusive_bonus_amount ||
                                  pageData.product_information.bonus_amount) &&
                                pageData.product_information.bonus_match
                              "
                              >+</template
                            >
                            <template
                              v-if="pageData.product_information.freespin"
                            >
                              <template
                                v-if="pageData.show_freebie_currency === '1'"
                                >{{
                                  pageData.product_information.freespin
                                    | currency(
                                      pageData.product_information
                                        .bonus_currency
                                    )
                                }}</template
                              >
                              <template v-else>{{
                                pageData.product_information.freespin
                              }}</template>
                              {{ pageData.product_information.freebie_name }}
                            </template>
                            <template v-else>{{
                              pageData.product_information.freebie_name
                            }}</template>
                          </template>
                        </template>
                      </template>
                    </span>
                    <!-- <span class="custom-font-1" style="color: red" v-else>
                      {{ $root.i18n.partner_is_not_available_for_your_country }}
                    </span> -->
                  </div>
                </div>
                <div class="half-column" v-if="pageData && pageData.product_id">
                  <div class="play_term_wrapper">
                    <template v-if="pageData.product_information.go_link">
                      <a
                        :title="pageData.product_information.name"
                        :href="
                          getGoLink(
                            pageData.product_information.go_link,
                            pageData.product_information.slug
                          )
                        "
                        :class="{
                          'cta cta-primary cta-promotion custom-btn cas-link hover-btn btn-cust': true,
                          'text-white':
                        !$root.override_ctabtntxt_color &&
                        !getContrastYIQ($root.color_schema.primary_btn),
                      'text-gray':
                        !$root.override_ctabtntxt_color &&
                        getContrastYIQ($root.color_schema.primary_btn),
                      'text-cta-override': $root.override_ctabtntxt_color,
                        }"
                        target="_blank"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        :style="{
                          '--primary-btn': $root.color_schema.primary_btn,
                          '--primary-btn-hover': pSBC(
                            -0.2,
                            $root.color_schema.primary_btn
                          ),
                        }"
                        ><span class="cta-text">{{
                          pageData.product_information.cta_button_text
                        }}</span
                        ><span
                          class="hover-text"
                          v-for="(char, indexGo) in $root.i18n.go_to_casino"
                          :key="indexGo + `revbpp`"
                          >{{ char }}</span
                        >
                        <!--<span
                          class="hover-text"
                          v-for="(char,
                          indexPro) in pageData.product_information.name.split(
                            ''
                          )"
                          :key="indexPro + `revb`"
                          >{{ char }}</span
                        >--></a
                      >
                    </template>
                  </div>
                </div>
              </div>
              <div class="bonus-card-content-bottom">
                <span class="span-h6">{{
                  getPartnerGlobalString(
                    $root.i18n.why_to_choose,
                    pageData.product_information.name
                  )
                }}</span>
                <ul class="proslist-rev">
                  <li
                    v-for="(procon, index) in prosconsReview(pageData.procons)"
                    :key="index"
                    :class="{
                      pros: procon.is_positive === '1',
                      cons: procon.is_positive === '0',
                    }"
                  >
                    {{ procon.description }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="rev-terms-condition"
            v-if="
              (pageData.bonus_tc && pageData.bonus_tc != '') ||
              (pageData.terms && pageData.terms != '')
            "
          >
            <span
              class="terms_tc cas-term"
              v-if="pageData.bonus_tc && pageData.bonus_tc != ''"
              v-html="pageData.bonus_tc"
              :style="{
                '--primary-btn': $root.color_schema.primary_btn,
              }"
            ></span>
            <span
              class="card-stroke"
              v-if="
                pageData.bonus_tc &&
                pageData.terms &&
                pageData.bonus_tc != '' &&
                pageData.terms != ''
              "
              >|</span
            >
            <a
              :rel="
                $root.change_cta_to_sponsored
                  ? 'nofollow sponsored'
                  : 'nofollow'
              "
              class="terms_tc cas-term"
              v-if="pageData.terms && pageData.terms != ''"
              :title="pageData.product_information.name"
              :href="getGoLink(pageData.term_link, pageData.slug)"
              target="_blank"
              >{{ pageData.terms }}</a
            >
          </div>
        </template>

        <template
          v-if="
            metaData &&
            metaData.security_information &&
            metaData.security_white_box_section
          "
        >
          <div
            class="max-cntent-area"
            v-if="
              metaData.security_information.title != '' &&
              metaData.security_information.content != ''
            "
          >
            <h2 class="custom-font-1">
              {{ metaData.security_information.title }}
            </h2>
            <div
              class="custom-font"
              :style="{
                '--heading-font': $root.font_family.heading,
                '--paragraph-font': $root.font_family.paragraph,
              }"
              v-html="metaData.security_information.content"
            ></div>
          </div>
          <div
            class="
              casino-card
              casino-card-software
              casino-card-payment-method
              casino-card-security
            "
            v-if="
              metaData.security_white_box_section.title_1 != '' &&
              metaData.security_white_box_section.content_1 != '' &&
              metaData.security_white_box_section.title_2 != '' &&
              metaData.security_white_box_section.content_2 != ''
            "
          >
            <div class="card-icon">
              <img
                :src="
                  $root.site_url +
                  $root.asset_path +
                  '/svg-icons/security-icon.svg'
                "
                alt="Security Icons"
              />
            </div>
            <div class="card-content">
              <div class="card-content-bottom">
                <div class="half-column half-column__review">
                  <div class="half-column-img">
                    <img
                      v-if="$root.enable_lazyload"
                      v-lazy="metaData.security_white_box_section.image_1"
                      alt="Security Image"
                    />
                    <img
                      v-else
                      :src="metaData.security_white_box_section.image_1"
                      alt="Security Image"
                    />
                  </div>
                  <div class="half-column-text">
                    <p class="p-caption">
                      {{ metaData.security_white_box_section.title_1 }}
                    </p>
                    <p class="custom-font-2">
                      {{ metaData.security_white_box_section.content_1 }}
                    </p>
                  </div>
                </div>
                <div class="half-column half-column__review">
                  <div class="half-column-img">
                    <img
                      v-if="$root.enable_lazyload"
                      v-lazy="metaData.security_white_box_section.image_2"
                      alt="Security Image"
                    />
                    <img
                      v-else
                      :src="metaData.security_white_box_section.image_2"
                      alt="Security Image"
                    />
                  </div>
                  <div class="half-column-text">
                    <p class="p-caption">
                      {{ metaData.security_white_box_section.title_2 }}
                    </p>
                    <p class="custom-font-2">
                      {{ metaData.security_white_box_section.content_2 }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </section>

    <!-- Similar Casino Cards -->
    <template
      v-if="
        pageData &&
        pageData.similar_casinos &&
        pageData.similar_casinos.length != 0 &&
        pageIndex > 1
      "
    >
      <SimilarCasino
        :assetsSize="assets_images"
        :componentTitle="
          metaData.similar_casinos_title ? metaData.similar_casinos_title : ''
        "
        :componentDescription="
          metaData.similar_casinos_description
            ? metaData.similar_casinos_description
            : ''
        "
        :componentAttrs="{}"
        :componentData="pageData.similar_casinos"
        :pageTemplate="'review-page'"
      />
    </template>
    <!-- Similar Casino Cards ends -->

    <!--Related Page Links-->
    <template v-if="morePaymentBottom && pageIndex > 3">
      <RelatedLinks :relatedLinkData="morePaymentBottom" />
    </template>
    <!--End Related Page Links-->

    <!--Author Block-->
    <template v-if="auhtorBlockdata && pageIndex > 3">
      <Author :authorData="auhtorBlockdata" />
    </template>
    <!--End Author Block-->
  </main>
</template>

<script>
import SimilarCasino from "@/components/layouts/SimilarCasino";

import StarRating from "@/components/ui/StarRating";
import Breadcrumb from "@/components/layouts/Breadcrumb";
import RelatedLinks from "@/components/custom-block/RelatedLinks";
import ContentIcon from "@/components/custom-block/ContentIcon";
import BonusInformation from "@/components/custom-block/BonusInformation";
import ComparisonList from "@/components/custom-block/ComparisonList";
import PromotionBannerSuggest from "@/components/custom-block/PromotionBannerSuggest";
import Author from "@/components/custom-block/Author";
import NotSupportModal from "@/components/custom-block/NotSupportModal";
import NotFound from "@/pages/404";
import currency from "@/misc/currency";
import { getLang } from "@/misc/lang";
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";
import { metaChanger } from "@/misc/meta-changer";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "Review",
  props: ["reviewData"],
  components: {
    StarRating,
    SimilarCasino,
    Breadcrumb,
    RelatedLinks,
    ContentIcon,
    PromotionBannerSuggest,
    ComparisonList,
    BonusInformation,
    Author,
    NotSupportModal,
    NotFound,
  },
  filters: {
    currency,
  },
  data() {
    return {
      pageAttr: {
        type: Object,
        default: () => {},
      },
      pageData: {
        type: Object,
        default: () => {},
      },
      tabData: {},
      supportEmail: "",
      contactName: "",
      contactNumber: "",
      breadCrumb: {
        type: Array,
        default: () => [],
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      supportedLang: {
        type: Array,
        default: () => [],
      },
      showHideObj: {
        spTop: false,
        pmTop: false,
        liscTop: false,
        spMidSc: false,
        liscUnderSc: false,
        dipositSc: false,
        withdrawSc: false,
      },
      activeKey: "",
      scrollOffset: 0,
      metaData: "",
      busy: false,
      pageIndex: 0,
      stickyNavTop: 0,
      showSticky: true,
      clickCount: 0,
      topStickyHeight: 0,
      topHeaderStickyHeight: 0,
      hideBonusLabel: false,
      hideToplistLabel: false,
      auhtorBlockdata: [],
      typeCheck: "",
    };
  },
  methods: {
    pSBC,
    getContrastYIQ,
    metaChanger,
    getOffset,
    getLang,
    getStarPercentage: function (rating) {
      // Direct fill color
      // if (rating === 1) {
      //   return {
      //     background:
      //       "linear-gradient(90deg,#dd1d00 -2.17%,#dd1d00 37.74%,#dd1d00 72.86%,#dd1d00 100%)",
      //     width: (rating / 5) * 100 + "%",
      //   };
      // } else if (rating > 1 && rating <= 3) {
      //   return {
      //     background:
      //       "linear-gradient(90deg,#f6ad00 -2.17%,#f6ad00 37.74%,#f6ad00 72.86%,#f6ad00 100%)",
      //     width: (rating / 5) * 100 + "%",
      //   };
      // } else if (rating > 3 && rating <= 5) {
      //   return {
      //     background:
      //       "linear-gradient(90deg,#4caf50 -2.17%,#4caf50 37.74%,#4caf50 72.86%,#4caf50 100%)",
      //     width: (rating / 5) * 100 + "%",
      //   };
      // }

      //// Gradient color
      if (rating === 1) {
        return {
          background:
            "linear-gradient(90deg,#dd1d00 -2.17%,#dd1d00 37.74%,#dd1d00 72.86%,#dd1d00 100%)",
          width: (rating / 5) * 100 + "%",
        };
      } else if (rating > 1 && rating <= 3) {
        return {
          background:
            "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#f6ad00 72.86%,#f6ad00 100%)",
          width: (rating / 5) * 100 + "%",
        };
      } else if (rating > 3 && rating <= 5) {
        if (rating > 3 && rating <= 4) {
          return {
            background:
              "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#7cdd00 72.86%,#7cdd00 100%)",
            width: (rating / 5) * 100 + "%",
          };
        } else {
          return {
            background:
              "linear-gradient(90deg,#dd1d00 -2.17%,#f6ad00 37.74%,#7cdd00 72.86%,#68c783 100%)",
            width: (rating / 5) * 100 + "%",
          };
        }
      }
    },
    prosconsReview: function (value) {
      let filterpositiveValue = value.filter((ele) => ele.is_positive === "1");
      let negativeValue = value.filter((elem) => elem.is_positive === "0");

      if (negativeValue.length > 0) {
        if (filterpositiveValue.length > 0) {
          let retArr = [
            ...filterpositiveValue.slice(0, 3),
            ...negativeValue.slice(0, 1),
          ];
          return retArr;
        }
      } else {
        if (filterpositiveValue.length > 0) {
          return filterpositiveValue.slice(0, 4);
        }
      }
    },
    getFinalStarPercentage: function (rating) {
      if (rating === 1) {
        return "#dd1d00";
      } else if (rating > 1 && rating <= 3) {
        return "#f6ad00";
      } else if (rating > 3 && rating <= 5) {
        return "#4caf50";
      }
    },
    getFinalStarPercentageLabel: function (rating) {
      if (rating > 0 && rating <= 3) {
        return this.$root.i18n.review_1_to_3_rating_label;
      } else if (rating > 3 && rating <= 5) {
        return this.$root.i18n.review_4_to_5_rating_label;
      }
    },
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    getBonusShowHide: function (partner) {
      let hideBonus = this.getCASToplistShowHideData(partner);
      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
    updateBonusHeight: function () {
      let heightArr = [];
      document.querySelectorAll(".sticky-inner").forEach((ele) => {
        heightArr.push(ele.clientHeight);
      });
      this.topStickyHeight = Math.max(...heightArr);
      if (document.getElementById("review-sticky-card")) {
        if (window.innerWidth > 991) {
          document.getElementById("review-sticky-card").style.top = `-${
            this.topStickyHeight + 1
          }px`;
        } else {
          document.getElementById("review-sticky-card").style.top = null;
        }
      }

      this.topHeaderStickyHeight = document.getElementById("sticky-header")
        ? document.getElementById("sticky-header").offsetHeight
        : 0;
      document.querySelectorAll(".sticky-review-card").forEach((ele) => {
        ele.style.height = `${Math.max(...heightArr)}px`;
      });
    },
    loadMore: function () {
      this.busy = true;
      this.pageIndex++;

      this.busy = false;
    },
    getPageData: function () {
      HttpService.getBody(
        this.$root.wp_country && this.$root.wp_country != ""
          ? this.$root.wp_country
          : this.$cookies.get("wp-country"),
        this.$root.wp_state && this.$root.wp_state != ""
          ? this.$root.wp_state
          : this.$cookies.get("wp-state"),
        this.$route.params.postSlug,
        this.$root.user_id
      )
        .then((res) => {
          // this.pageData = res.data.data.content.blocks
          //   .filter((ele) => ele.blockName === "wpvcb/review-details")
          //   .shift()
          //   ? res.data.data.content.blocks
          //       .filter((ele) => ele.blockName === "wpvcb/review-details")
          //       .shift().filtered_content
          //   : "";
          this.pageData = res.data.data.partner;
          if (this.pageData) {
            if (
              this.pageData.product_information &&
              this.pageData.product_information.support_email.length > 0
            ) {
              this.supportEmail =
                this.pageData.product_information.support_email[0].email_address;
            } else {
              this.supportEmail = "";
            }
            if (
              this.pageData.product_information &&
              this.pageData.product_information.contact_number.length > 0
            ) {
              this.contactNumber =
                this.pageData.product_information.contact_number[0].contact_number;
              this.contactName =
                this.pageData.product_information.contact_number[0].title;
            } else {
              this.contactNumber = "";
              this.contactName = "";
            }
            if (this.pageData.supported_language) {
              this.supportedLang = JSON.parse(
                this.pageData.supported_language.language_name
              ).map((ele) => this.getLang(ele));
            } else {
              this.supportedLang = [];
            }
          }

          this.metaData = res.data.data.meta;
          // this.pageAttr = res.data.data.content.blocks
          //   .filter((ele) => ele.blockName === "wpvcb/review-details")
          //   .shift()
          //   ? res.data.data.content.blocks
          //       .filter((ele) => ele.blockName === "wpvcb/review-details")
          //       .shift().attrs
          //   : "";
          this.pageAttr = res.data.data.attrs;

          this.tabData = res.data.data.review_details.tab;

          this.breadCrumb = res.data.data.breadcrumb;

          // More Payments Bottom Card
          this.morePaymentBottom = res.data.data.meta.more_payment_method;

          // Author Blocks Filtered
          let atBlock = res.data.data.content.blocks.filter((ele) => {
            if (ele.blockName === "wpvcb/author-block") {
              return ele.filtered_content;
            }
          });
          if (atBlock.length > 0)
            this.auhtorBlockdata = atBlock.shift().filtered_content;

          // Schema Append
          document.getElementById("schema-script").innerHTML =
            res.data.data.schema;

          // Adminbar Data
          this.$root.adminBarData =
            Object.keys(res.data.data.toolbar).length > 0
              ? res.data.data.toolbar
              : "";
          this.$root.disable = this.$root.adminBarData
            ? this.$root.adminBarData.visible
            : false;

          //NotSupportBanner
          this.$root.notsupportbannerData =
            res.data.data.not_supported_banner &&
            Object.keys(res.data.data.not_supported_banner).length > 0
              ? res.data.data.not_supported_banner
              : "";
          this.$root.disableNotSupportBanner =
            this.pageData && this.pageData.product_id ? false : true;

          this.$root.noScroll =
            this.pageData && this.pageData.product_id ? false : true;
          this.$root.notsupportassetSizes =
            Object.keys(this.$root.asset_sizes).length > 0
              ? this.$root.asset_sizes
              : "";
          this.$root.notSupportPageType = "review";

          // Assets Sizes
          this.assets_images =
            Object.keys(this.$root.asset_sizes).length > 0
              ? this.$root.asset_sizes
              : "";
          if (this.pageData) this.getBonusShowHide(this.pageData);
          if (
            this.tabData.length === 0 ||
            (this.tabData &&
              this.tabData.filter((ele) => ele.tab_content).length === 0)
          ) {
            this.pageIndex = 2;
          }

          if (!this.$root.enable_lazyload) {
            this.pageIndex = 4;
            this.$root.show_footer = true;
          } else {
            this.$root.show_footer = false;
          }
          this.$root.loading = false;
          this.$root.body_loading_status = true;
        })
        .catch((err) => {
          this.typeCheck = "error";
          this.$root.loading = false;
        });
    },
    scrollPage: function (ref) {
      if (document.getElementById("panel-wrapper")) {
        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("panel-wrapper").offsetHeight +
                document.getElementById("sticky-regulation-banner")
                  .offsetHeight +
                document.getElementById("review-sticky-card").offsetHeight +
                document.getElementById("sticky-header").offsetHeight -
                10;
            } else {
              this.scrollOffset =
                20 +
                document.getElementById("panel-wrapper").offsetHeight +
                document.getElementById("sticky-regulation-banner")
                  .offsetHeight +
                document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("panel-wrapper").offsetHeight +
                document.getElementById("review-sticky-card").offsetHeight +
                document.getElementById("sticky-header").offsetHeight -
                10;
            } else {
              this.scrollOffset =
                20 +
                document.getElementById("panel-wrapper").offsetHeight +
                document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        } else {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("panel-wrapper").offsetHeight +
                document.getElementById("sticky-regulation-banner")
                  .offsetHeight +
                document.getElementById("sticky-header").offsetHeight -
                10;
            } else {
              this.scrollOffset =
                20 +
                document.getElementById("panel-wrapper").offsetHeight +
                document.getElementById("sticky-regulation-banner")
                  .offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("panel-wrapper").offsetHeight +
                document.getElementById("sticky-header").offsetHeight -
                10;
            }
          }
        }
      } else {
        if (document.getElementById("review-sticky-card")) {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("sticky-regulation-banner")
                  .offsetHeight +
                document.getElementById("review-sticky-card").offsetHeight +
                document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset =
                document.getElementById("sticky-regulation-banner")
                  .offsetHeight +
                document.getElementById("review-sticky-card").offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("review-sticky-card").offsetHeight +
                document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset =
                document.getElementById("review-sticky-card").offsetHeight;
            }
          }
        } else {
          if (document.getElementById("sticky-regulation-banner")) {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("sticky-regulation-banner")
                  .offsetHeight +
                document.getElementById("sticky-header").offsetHeight;
            } else {
              this.scrollOffset = document.getElementById(
                "sticky-regulation-banner"
              ).offsetHeight;
            }
          } else {
            if (document.getElementById("sticky-header")) {
              this.scrollOffset =
                document.getElementById("sticky-header").offsetHeight;
            }
          }
        }
      }

      let topLoc = 0;
      if (window.innerWidth <= 768) {
        if (this.stickyNavTop === 0 && this.clickCount === 0) {
          topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top) - 80 - 20;
          this.clickCount++;
        } else topLoc = Math.ceil(this.getOffset(this.$refs[ref][0]).top) - 80;
      } else {
        if (this.stickyNavTop === 0) {
          if (this.topHeaderStickyHeight === 0) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("sticky-header")) {
                topLoc = Math.ceil(
                  this.getOffset(this.$refs[ref][0]).top +
                    document.getElementById("sticky-header").offsetHeight -
                    this.scrollOffset -
                    144
                );
              } else {
                topLoc = Math.ceil(
                  this.getOffset(this.$refs[ref][0]).top -
                    this.scrollOffset -
                    49 -
                    20
                );
              }
            } else {
              if (document.getElementById("sticky-header")) {
                topLoc = Math.ceil(
                  this.getOffset(this.$refs[ref][0]).top +
                    document.getElementById("sticky-header").offsetHeight -
                    this.scrollOffset -
                    165
                );
              } else {
                topLoc = Math.ceil(
                  this.getOffset(this.$refs[ref][0]).top -
                    this.scrollOffset -
                    70 -
                    20
                );
              }
            }
          } else {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(
                this.getOffset(this.$refs[ref][0]).top +
                  document.getElementById("sticky-header").offsetHeight -
                  this.scrollOffset -
                  70 -
                  20
              );
            } else {
              topLoc = Math.ceil(
                this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70
              );
            }
          }
        } else if (
          this.stickyNavTop === document.getElementById("panel-wrapper")
            ? document.getElementById("panel-wrapper").offsetHeight
            : ""
        ) {
          if (document.getElementById("sticky-header")) {
            topLoc = Math.ceil(
              this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 120
            );
          } else {
            topLoc = Math.ceil(
              this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 70
            );
          }
        } else {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(
                this.getOffset(this.$refs[ref][0]).top -
                  this.scrollOffset -
                  70 -
                  20
              );
            } else {
              topLoc = Math.ceil(
                this.getOffset(this.$refs[ref][0]).top - this.scrollOffset - 40
              );
            }
          } else {
            if (document.getElementById("sticky-header")) {
              topLoc = Math.ceil(
                this.getOffset(this.$refs[ref][0]).top -
                  this.scrollOffset -
                  50 -
                  20
              );
            } else {
              topLoc = Math.ceil(
                this.getOffset(this.$refs[ref][0]).top -
                  this.scrollOffset -
                  50 -
                  20
              );
            }
          }
        }
      }

      window.scrollTo({ top: topLoc, behavior: "smooth" });
    },
  },
  created: function () {
    if (
      this.$root.routes_meta[this.$route.params.postSlug] &&
      this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );

    if (this.reviewData != undefined) {
      // this.pageData = this.reviewData.content.blocks
      //   .filter((ele) => ele.blockName === "wpvcb/review-details")
      //   .shift()
      //   ? this.reviewData.content.blocks
      //       .filter((ele) => ele.blockName === "wpvcb/review-details")
      //       .shift().filtered_content
      //   : "";
      this.pageData = this.reviewData.partner;
      if (this.pageData) {
        if (
          this.pageData.product_information &&
          this.pageData.product_information.support_email.length > 0
        ) {
          this.supportEmail =
            this.pageData.product_information.support_email[0].email_address;
        } else {
          this.supportEmail = "";
        }
        if (
          this.pageData.product_information &&
          this.pageData.product_information.contact_number.length > 0
        ) {
          this.contactNumber =
            this.pageData.product_information.contact_number[0].contact_number;
          this.contactName =
            this.pageData.product_information.contact_number[0].title;
        } else {
          this.contactNumber = "";
          this.contactName = "";
        }

        if (this.pageData.supported_language) {
          this.supportedLang = JSON.parse(
            this.pageData.supported_language.language_name
          ).map((ele) => this.getLang(ele));
        } else {
          this.supportedLang = [];
        }
      }

      this.metaData = this.reviewData.meta;
      // this.pageAttr = this.reviewData.content.blocks
      //   .filter((ele) => ele.blockName === "wpvcb/review-details")
      //   .shift()
      //   ? this.reviewData.content.blocks
      //       .filter((ele) => ele.blockName === "wpvcb/review-details")
      //       .shift().attrs
      //   : "";
      this.pageAttr = this.reviewData.attrs;

      this.tabData = this.reviewData.review_details.tab;

      this.breadCrumb = this.reviewData.breadcrumb;

      // More Payments Bottom Card
      this.morePaymentBottom = this.reviewData.meta.more_payment_method;

      // Author Blocks Filtered
      let atBlock = this.reviewData.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0)
        this.auhtorBlockdata = atBlock.shift().filtered_content;

      // Schema Append
      document.getElementById("schema-script").innerHTML =
        this.reviewData.schema;

      // Adminbar Data
      this.$root.adminBarData =
        Object.keys(this.reviewData.toolbar).length > 0
          ? this.reviewData.toolbar
          : "";
      this.$root.disable = this.$root.adminBarData
        ? this.$root.adminBarData.visible
        : false;

      //NotSupportBanner
      this.$root.notsupportbannerData =
        this.reviewData.not_supported_banner &&
        Object.keys(this.reviewData.not_supported_banner).length > 0
          ? this.reviewData.not_supported_banner
          : "";
      this.$root.disableNotSupportBanner =
        this.pageData && this.pageData.product_id ? false : true;

      this.$root.noScroll =
        this.pageData && this.pageData.product_id ? false : true;
      this.$root.notsupportassetSizes =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";
      this.$root.notSupportPageType = "review";

      // Assets Sizes
      this.assets_images =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";

      if (this.pageData) this.getBonusShowHide(this.pageData);

      if (
        this.tabData.length === 0 ||
        (this.tabData &&
          this.tabData.filter((ele) => ele.tab_content).length === 0)
      ) {
        this.pageIndex = 2;
      }

      if (!this.$root.enable_lazyload) {
        this.pageIndex = 4;
        this.$root.show_footer = true;
      } else {
        this.$root.show_footer = false;
      }
    } else {
      this.$root.loading = true;
      this.getPageData();
    }
  },
  mounted: function () {
    this.heightCheck();
    this.$nextTick(() => {
      this.updateBonusHeight();
    });
    var that = this;
    window.addEventListener(
      "scroll",
      function () {
        if (window.innerWidth > 991) {
          if (document.getElementById("panel-wrapper")) {
            if (document.getElementById("review-sticky-card")) {
              if (window.pageYOffset >= 338) {
                if (document.getElementById("sticky-regulation-banner")) {
                  document.getElementById(
                    "sticky-regulation-banner"
                  ).style.top = `${
                    document.getElementById("panel-wrapper").offsetHeight
                  }px`;
                  document.getElementById("review-sticky-card").style.top = `${
                    document.getElementById("panel-wrapper").offsetHeight +
                    document.getElementById("sticky-regulation-banner")
                      .offsetHeight
                  }px`;
                  if (document.getElementById("sticky-header")) {
                    document.getElementById("sticky-header").style.top = `${
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("review-sticky-card").offsetHeight
                    }px`;
                  }
                } else {
                  document.getElementById("review-sticky-card").style.top = `${
                    document.getElementById("panel-wrapper").offsetHeight
                  }px`;
                  if (document.getElementById("sticky-header")) {
                    document.getElementById("sticky-header").style.top = `${
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("review-sticky-card").offsetHeight
                    }px`;
                  }
                }
              } else {
                document.getElementById("review-sticky-card").style.top = `-${
                  that.topStickyHeight + 1
                }px`;
                if (document.getElementById("sticky-regulation-banner")) {
                  if (window.pageYOffset === 0) {
                    document.getElementById(
                      "sticky-regulation-banner"
                    ).style.top = 0;
                  } else {
                    document.getElementById(
                      "sticky-regulation-banner"
                    ).style.top = `${
                      document.getElementById("panel-wrapper").offsetHeight
                    }px`;
                  }
                  if (document.getElementById("sticky-header"))
                    document.getElementById("sticky-header").style.top = `${
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight
                    }px`;
                } else {
                  if (document.getElementById("sticky-header"))
                    document.getElementById("sticky-header").style.top = `${
                      document.getElementById("panel-wrapper").offsetHeight
                    }`;
                }
              }
              if (document.getElementById("sticky-nav")) {
                if (window.pageYOffset >= 550) {
                  if (document.getElementById("sticky-regulation-banner")) {
                    if (document.getElementById("sticky-header")) {
                      that.stickyNavTop =
                        document.getElementById("panel-wrapper").offsetHeight +
                        document.getElementById("review-sticky-card")
                          .offsetHeight +
                        document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                        document.getElementById("sticky-header").offsetHeight;
                    } else {
                      that.stickyNavTop =
                        document.getElementById("panel-wrapper").offsetHeight +
                        document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                        document.getElementById("review-sticky-card")
                          .offsetHeight;
                    }
                  }
                } else {
                  that.stickyNavTop =
                    document.getElementById("panel-wrapper").offsetHeight;
                }
              }
            } else {
              if (document.getElementById("sticky-nav")) {
                if (window.pageYOffset >= 550) {
                  if (document.getElementById("sticky-regulation-banner")) {
                    if (document.getElementById("sticky-header")) {
                      that.stickyNavTop =
                        document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                        document.getElementById("panel-wrapper").offsetHeight +
                        document.getElementById("sticky-header").offsetHeight;
                    } else {
                      that.stickyNavTop =
                        document.getElementById("panel-wrapper").offsetHeight +
                        document.getElementById("sticky-regulation-banner")
                          .offsetHeight;
                    }
                  } else {
                    if (document.getElementById("sticky-header")) {
                      that.stickyNavTop =
                        document.getElementById("panel-wrapper").offsetHeight +
                        document.getElementById("sticky-header").offsetHeight;
                    } else {
                      that.stickyNavTop =
                        document.getElementById("panel-wrapper").offsetHeight;
                    }
                  }
                } else {
                  that.stickyNavTop =
                    document.getElementById("panel-wrapper").offsetHeight;
                }
              }
            }
          } else {
            if (document.getElementById("review-sticky-card")) {
              if (window.pageYOffset >= 338) {
                if (document.getElementById("sticky-regulation-banner")) {
                  document.getElementById(
                    "sticky-regulation-banner"
                  ).style.top = 0;
                  document.getElementById("review-sticky-card").style.top = `${
                    document.getElementById("sticky-regulation-banner")
                      .offsetHeight
                  }px`;
                  if (document.getElementById("sticky-header")) {
                    document.getElementById("sticky-header").style.top = `${
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("review-sticky-card").offsetHeight
                    }px`;
                  }
                } else {
                  document.getElementById("review-sticky-card").style.top = 0;
                  if (document.getElementById("sticky-header")) {
                    document.getElementById("sticky-header").style.top = `${
                      document.getElementById("review-sticky-card").offsetHeight
                    }px`;
                  }
                }
              } else {
                document.getElementById("review-sticky-card").style.top = `-${
                  that.topStickyHeight + 1
                }px`;
                if (document.getElementById("sticky-regulation-banner")) {
                  document.getElementById(
                    "sticky-regulation-banner"
                  ).style.top = 0;
                  if (document.getElementById("sticky-header")) {
                    document.getElementById("sticky-header").style.top = `${
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight
                    }px`;
                  }
                } else {
                  if (document.getElementById("sticky-header"))
                    document.getElementById("sticky-header").style.top = 0;
                }
              }
              if (document.getElementById("sticky-nav")) {
                if (window.pageYOffset >= 550) {
                  if (document.getElementById("sticky-regulation-banner")) {
                    if (document.getElementById("sticky-header")) {
                      that.stickyNavTop =
                        document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                        document.getElementById("review-sticky-card")
                          .offsetHeight +
                        document.getElementById("sticky-header").offsetHeight;
                    } else {
                      that.stickyNavTop =
                        document.getElementById("sticky-regulation-banner")
                          .offsetHeight +
                        document.getElementById("review-sticky-card")
                          .offsetHeight;
                    }
                  } else {
                    if (document.getElementById("sticky-header")) {
                      that.stickyNavTop =
                        document.getElementById("review-sticky-card")
                          .offsetHeight +
                        document.getElementById("sticky-header").offsetHeight;
                    } else {
                      that.stickyNavTop =
                        document.getElementById(
                          "review-sticky-card"
                        ).offsetHeight;
                    }
                  }
                } else {
                  that.stickyNavTop = 0;
                }
              }
            } else {
              if (document.getElementById("sticky-nav")) {
                //if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop =
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = document.getElementById(
                      "sticky-regulation-banner"
                    ).offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop =
                      document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop = 0;
                  }
                }
                // } else {
                //   that.stickyNavTop = 0;
                // }
              }
            }
          }
        } else {
          if (
            that.$root.show_stickymenu &&
            that.$root.show_stickymenu_mobile &&
            window.innerWidth < 992
          ) {
            that.stickyNavTop = 70;
          }
        }

        if (document.getElementById("sticky-nav")) {
          let stickyParent = document.getElementById("sticky-nav").parentNode;
          if (
            window.pageYOffset >
            Math.ceil(
              that.getOffset(stickyParent).top +
                stickyParent.clientHeight -
                window.innerHeight +
                400
            )
          ) {
            //that.showSticky = false;
            that.stickyNavTop = 0;
          } else {
            that.showSticky = true;
            if (
              that.$root.show_stickymenu &&
              that.$root.show_stickymenu_mobile &&
              window.innerWidth < 992
            ) {
              that.stickyNavTop = 70;
            }
          }

          if (document.getElementById("review-sticky-card")) {
            if (document.getElementById("sticky-regulation-banner")) {
              if (document.getElementById("sticky-header")) {
                that.scrollOffset =
                  document.getElementById("sticky-regulation-banner")
                    .offsetHeight +
                  document.getElementById("review-sticky-card").offsetHeight +
                  document.getElementById("sticky-header").offsetHeight;
              } else {
                that.scrollOffset =
                  document.getElementById("sticky-regulation-banner")
                    .offsetHeight +
                  document.getElementById("review-sticky-card").offsetHeight;
              }
            } else {
              if (document.getElementById("sticky-header")) {
                that.scrollOffset =
                  document.getElementById("review-sticky-card").offsetHeight +
                  document.getElementById("sticky-header").offsetHeight;
              } else {
                that.scrollOffset =
                  document.getElementById("review-sticky-card").offsetHeight;
              }
            }
          }

          Object.keys(that.$refs).forEach((key) => {
            if (that.$refs[key][0]) {
              if (window.innerWidth <= 768) {
                if (
                  Math.ceil(window.pageYOffset) >=
                  Math.ceil(that.getOffset(that.$refs[key][0]).top) - 80
                ) {
                  that.activeKey = key;
                  that.clickCount++;
                }
              } else {
                if (document.getElementById("panel-wrapper")) {
                  if (document.getElementById("sticky-regulation-banner")) {
                    if (document.getElementById("sticky-header")) {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            70 -
                            50 -
                            20
                        )
                      ) {
                        that.activeKey = key;
                      }
                    } else {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            50 -
                            40
                        )
                      ) {
                        that.activeKey = key;
                      }
                    }
                  } else {
                    if (document.getElementById("sticky-header")) {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            70 -
                            20
                        )
                      ) {
                        that.activeKey = key;
                      }
                    } else {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            40
                        )
                      ) {
                        that.activeKey = key;
                      }
                    }
                  }
                } else {
                  if (document.getElementById("sticky-regulation-banner")) {
                    if (document.getElementById("sticky-header")) {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            50 -
                            50 -
                            20
                        )
                      ) {
                        that.activeKey = key;
                      }
                    } else {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            70 -
                            50 -
                            20
                        )
                      ) {
                        that.activeKey = key;
                      }
                    }
                  } else {
                    if (document.getElementById("sticky-header")) {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            50 -
                            20
                        )
                      ) {
                        that.activeKey = key;
                      }
                    } else {
                      if (
                        Math.ceil(window.pageYOffset) >=
                        Math.ceil(
                          that.getOffset(that.$refs[key][0]).top -
                            that.scrollOffset -
                            70 -
                            20
                        )
                      ) {
                        that.activeKey = key;
                      }
                    }
                  }
                }
              }
            }
          });
        }

        //that.heightCheck();
      },
      { passive: true }
    );
    window.addEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      {
        passive: true,
      }
    );
    window.addEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
      let windowWidth = window.innerWidth;
      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }
      if (window.innerWidth > 991) {
        if (document.getElementById("panel-wrapper")) {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById(
                  "sticky-regulation-banner"
                ).style.top = `${
                  document.getElementById("panel-wrapper").offsetHeight
                }px`;
                document.getElementById("review-sticky-card").style.top = `${
                  document.getElementById("panel-wrapper").offsetHeight +
                  document.getElementById("sticky-regulation-banner")
                    .offsetHeight
                }px`;
                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = `${
                    document.getElementById("sticky-regulation-banner")
                      .offsetHeight +
                    document.getElementById("panel-wrapper").offsetHeight +
                    document.getElementById("review-sticky-card").offsetHeight
                  }px`;
                }
              } else {
                document.getElementById("review-sticky-card").style.top = `${
                  document.getElementById("panel-wrapper").offsetHeight
                }px`;
                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = `${
                    document.getElementById("panel-wrapper").offsetHeight +
                    document.getElementById("review-sticky-card").offsetHeight
                  }px`;
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = `-${
                that.topStickyHeight + 1
              }px`;
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById(
                  "sticky-regulation-banner"
                ).style.top = `${
                  document.getElementById("panel-wrapper").offsetHeight
                }`;
                if (document.getElementById("sticky-header"))
                  document.getElementById("sticky-header").style.top = `${
                    document.getElementById("panel-wrapper").offsetHeight +
                    document.getElementById("sticky-regulation-banner")
                      .offsetHeight
                  }px`;
              } else {
                if (document.getElementById("sticky-header"))
                  document.getElementById("sticky-header").style.top = `${
                    document.getElementById("panel-wrapper").offsetHeight
                  }`;
              }
            }
            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop =
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("review-sticky-card")
                        .offsetHeight +
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop =
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("review-sticky-card")
                        .offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop =
                  document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop =
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop =
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop =
                      document.getElementById("panel-wrapper").offsetHeight +
                      document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop =
                      document.getElementById("panel-wrapper").offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop =
                  document.getElementById("panel-wrapper").offsetHeight;
              }
            }
          }
        } else {
          if (document.getElementById("review-sticky-card")) {
            if (window.pageYOffset >= 338) {
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById(
                  "sticky-regulation-banner"
                ).style.top = 0;
                document.getElementById("review-sticky-card").style.top = `${
                  document.getElementById("sticky-regulation-banner")
                    .offsetHeight
                }px`;
                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = `${
                    document.getElementById("sticky-regulation-banner")
                      .offsetHeight +
                    document.getElementById("review-sticky-card").offsetHeight
                  }px`;
                }
              } else {
                document.getElementById("review-sticky-card").style.top = 0;
                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = `${
                    document.getElementById("review-sticky-card").offsetHeight
                  }px`;
                }
              }
            } else {
              document.getElementById("review-sticky-card").style.top = `-${
                that.topStickyHeight + 1
              }px`;
              if (document.getElementById("sticky-regulation-banner")) {
                document.getElementById(
                  "sticky-regulation-banner"
                ).style.top = 0;
                if (document.getElementById("sticky-header")) {
                  document.getElementById("sticky-header").style.top = `${
                    document.getElementById("sticky-regulation-banner")
                      .offsetHeight
                  }px`;
                }
              } else {
                if (document.getElementById("sticky-header"))
                  document.getElementById("sticky-header").style.top = 0;
              }
            }
            if (document.getElementById("sticky-nav")) {
              if (window.pageYOffset >= 550) {
                if (document.getElementById("sticky-regulation-banner")) {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop =
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("review-sticky-card")
                        .offsetHeight +
                      document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop =
                      document.getElementById("sticky-regulation-banner")
                        .offsetHeight +
                      document.getElementById("review-sticky-card")
                        .offsetHeight;
                  }
                } else {
                  if (document.getElementById("sticky-header")) {
                    that.stickyNavTop =
                      document.getElementById("review-sticky-card")
                        .offsetHeight +
                      document.getElementById("sticky-header").offsetHeight;
                  } else {
                    that.stickyNavTop =
                      document.getElementById(
                        "review-sticky-card"
                      ).offsetHeight;
                  }
                }
              } else {
                that.stickyNavTop = 0;
              }
            }
          } else {
            if (document.getElementById("sticky-nav")) {
              //if (window.pageYOffset >= 550) {
              if (document.getElementById("sticky-regulation-banner")) {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop =
                    document.getElementById("sticky-regulation-banner")
                      .offsetHeight +
                    document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = document.getElementById(
                    "sticky-regulation-banner"
                  ).offsetHeight;
                }
              } else {
                if (document.getElementById("sticky-header")) {
                  that.stickyNavTop =
                    document.getElementById("sticky-header").offsetHeight;
                } else {
                  that.stickyNavTop = 0;
                }
              }
              // } else {
              //   that.stickyNavTop = 0;
              // }
            }
          }
        }
      } else {
        if (document.getElementById("panel-wrapper")) {
          that.stickyNavTop =
            document.getElementById("panel-wrapper").offsetHeight;
        } else {
          that.stickyNavTop = 0;
        }
      }
    });
  },
  beforeDestroy: function () {
    window.removeEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      {
        passive: true,
      }
    );
    window.removeEventListener("resize", function () {
      that.heightCheck();
      that.updateBonusHeight();
    });
    if (window.innerWidth > 991) {
      document.getElementById("sticky-header")
        ? (document.getElementById("sticky-header").style.top = "0")
        : "";
    }
  },
  watch: {
    "$route.params.postSlug": function () {
      if (this.reviewData != undefined) {
      } else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    pageIndex: function () {
      if (this.pageIndex > 3) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.lang-img {
  height: 36px;
  width: 36px;
}

.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.pb-1 {
  padding-top: 1px !important;
}

.ct {
  &-inner-banner {
    padding: 0px 0 45px;
    background: #070438 url(~@/assets/images/top-bg.svg) no-repeat 0 0;
    .game-space {
      position: relative;
      min-height: 321px;
      @media (min-width: @sizes[extra-small]) {
        min-height: auto;
      }
      img {
        border-radius: 10px;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
        height: 100%;
        object-fit: cover;
        width: auto;
        max-height: 321px;
        min-height: 321px;
        @media (min-width: @sizes[extra-small]) {
          width: 100%;
          max-height: none;
          min-height: auto;
        }
      }
      &-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 20px;
        .display-flex();
        .align-items(center);
        .justify-content-center();
        .flex-direction-column();
        .button-block {
          .display-flex();
          .align-items(center);
          .justify-content-center();
          .flex-direction-column();
          width: 100%;
          margin-bottom: 15px;
          .cta {
            min-width: 100%;
            margin: 5px 0;
            font-weight: bold;
            font-size: 14px;
            line-height: 17px;
            padding: 10px 18px;
            @media (min-width: @sizes[medium]) {
              min-width: 330px;
              margin: 10px 0;
              padding: 15px 18px;
              font-size: 18px;
              line-height: 22px;
            }
          }
        }
        .game-logo {
          img {
            box-shadow: none;
            max-height: none;
            min-height: auto;
          }
        }
      }
    }
    .row {
      .col-md-8 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 66.66666667%;
          float: left;
        }
      }
      .col-md-4 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 33.33333333%;
          float: left;
        }
      }
    }
    &-lft {
      margin-bottom: 19px;
      @media (min-width: @sizes[large]) {
        margin-bottom: 0;
      }
      @media (min-width: @sizes[extraX-large]) {
        width: 906px !important;
      }
    }
    &-rgt {
      @media (min-width: @sizes[extraX-large]) {
        width: 314px !important;
      }
    }
  }
}

.new-review-banner {
  &-card {
    padding: 12px 16px;
    .border-radius(12px);
    box-shadow: none;
    @media (min-width: @sizes[small]) {
      padding: 20px;
    }
    @media (min-width: @sizes[md-large]) {
      padding: 30px;
    }
    &-top {
      .display-flex();
      .flex-wrap(nowrap);
      .flex-direction-column();
      @media (min-width: @sizes[medium]) {
        .flex-wrap(wrap);
        .flex-direction-row();
      }
      &-left {
        .display-flex();
        .align-items-flex-start();
        .justify-content-center();
        width: auto;
        margin: 0 -7px 18px -6px;
        @media (min-width: @sizes[custom-small]) {
          margin: 0 -7px 18px 5px;
          justify-content: unset !important;
        }
        @media (min-width: @sizes[small]) {
          width: 100%;
          margin: 0 0px 28px;
          .justify-content-flex-start();
        }
        @media (min-width: @sizes[medium]) {
          margin: 0 0px 45px;
        }
        @media (min-width: @sizes[tablet]) {
          width: calc(100% - 400px);
          margin: 0 0px 5px;
        }
        @media (min-width: @sizes[sm-large]) {
          width: calc(100% - 430px);
        }
        @media (min-width: @sizes[md-large]) {
          width: calc(100% - 495px);
        }
        .review-left-img {
          min-width: 79px;
          max-width: 79px;
          height: 79px;
          background: @white;
          .border-radius(12px);
          .display-flex();
          .align-items(center);
          .justify-content-center();
          position: relative;
          a {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
            border-radius: 12px;
            overflow: visible;
            margin-top: 0px;
            @media (min-width: @sizes[medium]) {
              margin-top: 4px;
            }
            @media (min-width: @sizes[sm-large]) {
              margin-top: 4px;
            }
            @media (min-width: @sizes[md-large]) {
              margin-top: 0px;
            }
          }
          img {
            .border-radius(12px);
            @media (min-width: @sizes[medium]) {
              height: 100%;
              width: 100%;
            }
          }
          @media (min-width: @sizes[medium]) {
            min-width: 245px;
            max-width: 245px;
            height: 245px;
          }
          @media (min-width: @sizes[sm-large]) {
            min-width: 245px;
            max-width: 245px;
            height: 245px;
          }
          @media (min-width: @sizes[md-large]) {
            min-width: 250px;
            max-width: 250px;
            height: 250px;
          }
          .exclusive-tag {
            //display: block;
            position: absolute;
            //bottom: 4px;
            left: 0;
            right: 0;
            margin: auto;
            //width: 67px;
            height: 20px;
            font-size: 12px;
            line-height: 15px;
            //border-radius: 8px;
            width: 100%;
            bottom: 0;
            border-radius: 0;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            @media (min-width: @sizes[medium]) {
              //display: none;
              bottom: 14px;
              width: 210px;
              height: 28px;
              font-size: 17px;
              line-height: 28px;
              z-index: 10;
              border-radius: 8px;
            }
            img {
              width: 18px !important;
              height: 18px !important;
              border-radius: 0 !important;
              object-fit: contain !important;
              @media (max-width: @sizes[small]) {
                margin: 0px auto;
                width: 14px !important;
                height: 14px !important;
              }
            }
            p {
              @media (min-width: @sizes[small]) {
                font-weight: bold;
                margin-top: 0px;
                font-size: 12px;
                margin: 0;
              }
            }
            svg,
            img {
              @media (max-width: @sizes[medium]) {
                width: 12px;
              }
            }
          }
        }
        .review-left-content {
          padding: 10px 0 5px 15px;
          height: 100%;
          @media (min-width: @sizes[medium]) {
            padding: 0 30px;
          }
          .approve {
            font-weight: normal;
            font-size: 12px;
            line-height: 15px;
            color: @mid-gray;
            margin-bottom: 8px;
            margin-top: 10px;
            display: block;
            i {
              margin-right: 5px;
              @media (min-width: @sizes[small]) {
                margin-right: 7px;
              }
            }
            @media (min-width: @sizes[small]) {
              font-size: 14px;
              line-height: 17px;
              color: @lightestp;
            }
          }
          .exclusive-bar {
            .display-flex();
            .align-items(start);
            .flex-direction-column();
            .flex-wrap(wrap);
            margin-bottom: 0px;
            margin-top: 0px;
            @media (min-width: @sizes[medium]) {
              margin-bottom: 4px;
              margin-top: 0px;
            }
            @media (min-width: @sizes[sm-large]) {
              .align-items(start);
              .flex-direction-column();
              margin-bottom: 4px;
              margin-top: 0px;
            }
            @media (min-width: @sizes[md-large]) {
              .flex-direction-row();
              .align-items(center);
              margin-bottom: 4px;
              margin-top: 0px;
            }
            p {
              margin-bottom: 4px;
              font-weight: 400;
              color: @lightdark;
              padding-right: 7px;
              @media (min-width: @sizes[small]) {
                margin-bottom: 0;
              }
            }
            .exclusive-tag {
              margin-left: 30px;
              display: none;
              @media (min-width: @sizes[medium]) {
                display: none;
              }
            }
            &-rating {
              .display-flex();
              .align-items(center);
              width: 100%;
            }
            &-title {
              .display-flex();
              .flex-direction-column();
              width: 100%;
              @media (min-width: @sizes[medium]) {
                .flex-direction-row();
              }
              p {
                -webkit-box-ordinal-group: 3;
                -ms-flex-order: 2;
                order: 2;
                margin-bottom: 4px;
                margin-top: 4px;
                font-size:14px;
                @media (min-width: @sizes[medium]) {
                  -webkit-box-ordinal-group: 2;
                  -ms-flex-order: 1;
                  order: 1;
                  margin-bottom: 4px;
                  font-size:16px;
                }
              }
              .trust {
                .display-flex();
                .align-items(center);
                margin-left: 0px;
                -webkit-box-ordinal-group: 2;
                -ms-flex-order: 1;
                order: 1;
                margin-bottom: 5px;
                @media (min-width: @sizes[medium]) {
                  margin-left: 8px;
                  -webkit-box-ordinal-group: 3;
                  -ms-flex-order: 2;
                  order: 2;
                  margin-bottom: 0;
                }
                strong {
                  font-weight: bold;
                  font-size: 10px;
                  line-height: 1;
                  text-transform: uppercase;
                  color: #4caf50;
                }
                i {
                  background: #4caf50;
                  width: 8.35px;
                  height: 8.35px;
                  .border-radius(2px);
                  .display-inline-flex();
                  .align-items(center);
                  .justify-content-center();
                  margin-right: 3.65px;
                }
              }
            }
          }
          &-title {
            h1 {
              margin-bottom: 12px;
              @media (min-width: @sizes[sm-large]) {
                margin-bottom: 12px;
              }
            }
            .cta {
              min-width: 100%;
            }
            display: none;
            @media (min-width: @sizes[medium]) {
              display: block;
            }
          }
        }
      }
      .view-mob {
        display: block;
        text-align: center;
        h1 {
          margin-bottom: 17px;
          padding: 0 10%;
        }
        .cta-promo-review {
          font-size: 18px;
          line-height: 100%;
          margin-top: 0px;
          display: block;
        }
        @media (min-width: @sizes[medium]) {
          display: none;
        }
      }
      &-right {
        min-width: 100%;
        margin-top: 17px;
        border-top: 0;
        border-right: 0;
        border-left: 0;
        padding: 0;
        @media (min-width: @sizes[medium]) {
          width: calc(100% - 315px);
          min-width: calc(100% - 315px);
          border-right: 1px solid #e5e5e5;
          border-left: 0;
          padding: 0px 45px 0 0;
          margin-top: 0;
        }
        @media (min-width: @sizes[tablet]) {
          width: 400px;
          min-width: auto;
          padding: 0px 0 0 35px;
          border-right: 0;
          border-left: 1px solid #e5e5e5;
        }
        @media (min-width: @sizes[sm-large]) {
          width: 430px;
        }
        @media (min-width: @sizes[md-large]) {
          width: 495px;
        }
        h6 {
          margin-bottom: 3px;
          color: @gray-dimmer;
          @media (min-width: @sizes[small]) {
            margin: 0 0 3px 0;
            color: @lightdark;
          }
        }
        p {
          color: @gray-dimmer;
          @media (min-width: @sizes[small]) {
            margin: 0 0 20px 0;
            color: @mob-gray;
          }
        }
      }
    }
    &-bottom {
      .display-flex();
      .align-items(start);
      .justify-content-flex-start();
      .flex-direction-column();
      border-top: 0;
      padding: 16px 0 0;
      min-width: 100%;
      width: 100%;
      @media (min-width: @sizes[medium]) {
        padding: 0 0 0 45px;
        margin-top: 0px;
        .flex-direction-column();
        min-width: 315px;
        width: 315px;
      }
      @media (min-width: @sizes[tablet]) {
        border-top: 1px solid #e5e5e5;
        width: 100%;
        min-width: auto;
        padding: 24px 0 0;
        margin-top: 32px;
        .flex-direction-row();
      }
      .casino-card-lists {
        margin-bottom: 0px;
        @media (min-width: @sizes[medium]) {
          margin-bottom: 10px;
        }
        @media (min-width: @sizes[md-large]) {
          margin-bottom: 0;
        }
        &:nth-child(2) {
          ul {
            li {
              margin-right: 15px;
              &:last-child {
                margin-right: 0;
              }
              @media (min-width: @sizes[large]) {
                margin-right: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.ct {
  &-editor-section {
    .container {
      position: static;
    }
  }
}

.editor-content {
  .max-cntent-area {
    max-width: 960px;
  }
  h1 {
  }
  img {
    margin-bottom: 20px;
  }
  ul {
    list-style-type: none;
    padding: 0;
    li {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 25px;
      position: relative;
      padding-left: 20px;
      margin-bottom: 15px;
      span {
        font-weight: 700;
      }
    }
  }
}

#sticky-nav {
  padding-bottom: 30px;
}

.review-top-menu {
  padding-bottom: 30px;
  padding-top: 14px;
  background: @white;
  border-bottom: 1px solid @border-gray;
  //margin: 0 -15px 0px;
  padding: 0 14px;
  height: 53px;
  margin-bottom: 0px;
  .scroll-nav {
    .display-flex();
    .align-items(center);
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    border-bottom: 1px solid @border-gray;
    max-width: 1210px;
    margin: 0 auto;
    height: 53px;
    .scroll-item {
      margin-right: 30px;
      display: inline-block;
      padding: 10px 0px;
      position: relative;
      font-weight: 700;
      font-size: 18px;
      color: @lightdark;
      line-height: 25px;
      cursor: pointer;
      .transition(all 0.3s);
      // &:after {
      //   position: absolute;
      //   content: "";
      //   left: 0;
      //   bottom: -5px;
      //   width: 100%;
      //   height: 3px;
      //   background: @orange;
      //   .transition(all 0.3s);
      // }
      &:hover,
      &.active {
        color: var(--primary-btn);
        &:after {
          bottom: 0;
        }
      }
      &.active {
        font-weight: 700;
      }
    }
  }
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 5;
}

// Card Overflow fix
.casino-card-lists ul li {
  margin: 0 32px 0 0;
  padding: 0;
  list-style-type: none;
}

.casino-card-lang-lists ul {
  margin: 0;
}

.casino-card-lists ul {
  @media (min-width: @sizes[large]) {
    margin-bottom: 20px;
  }
}

.casino-card-lang-lists ul li {
  width: 36px;
  height: 36px;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  border-radius: 100%;
  overflow: hidden;
  margin: 0 6px 6px 0;
  padding: 0;
  border: 1px solid #bbbbbb;
}

.review-banner-card-top-right h6 {
  margin-bottom: 3px;
}

.new-review-banner-card-top-right h6 {
  margin-bottom: 3px;
}

.review-top-menu ul li a {
  padding: 10px 20px 10px 0;
  font-weight: 400;
  font-size: 16px;
  color: #9b9b9b;
  line-height: 25px;
}

.review-top-menu ul li a:active {
  padding: 10px 20px 10px 0;
  font-weight: 400;
  font-size: 16px;
  color: #9b9b9b;
  line-height: 25px;
}

.rating-wrapper-small .radio-star-total {
  padding-left: 10px;
  line-height: 20px;
}

.casino-card-lists ul li {
  margin: 0 12px 0 0;
  padding: 0;
  list-style-type: none;
  @media (min-width: 374px) {
    margin: 0 16px 0 0;
  }
}

.casino-card-lists__review {
  h6 {
    font-weight: 400;
  }
}

.bonus-card {
  &-logo {
    background: @white !important;
    height: 280px !important;
    a {
      text-align: center;
    }
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      border-radius: 12px 12px 0 0px;
      @media (min-width: @sizes[large]) {
        border-radius: 12px 0 0 12px;
        width: 100%;
      }
    }
    @media (min-width: @sizes[medium]) {
      height: 100% !important;
    }
  }
  &-content {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    @media (min-width: @sizes[medium]) {
      padding: 30px 45px;
    }
    &-top {
      width: 100%;
    }
  }
}

.justify-flex-start {
  justify-content: flex-start !important;
}

.license-right {
  @media (max-width: 990px) {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 10px !important;
  }
  @media (min-width: @sizes[large]) {
    text-align: right;
  }
}

.justify-flex-end {
  @media (min-width: @sizes[large]) {
    justify-content: flex-end !important;
  }
  li {
    &:last-child {
      margin-right: 0;
    }
  }
}

.casino-card-bonus {
  margin: 0;
  flex-direction: row;
  @media (min-width: @sizes[large]) {
    padding: 16px;
    min-height: 296px;
  }
  @media (min-width: @sizes[md-large]) {
    min-height: 296px;
    height: auto;
    //flex-direction: column;
  }
  .bonus-card-logo {
    padding: 16px;
    box-shadow: none;
    height: auto !important;
    min-height: 280px !important;
    position: relative;
    @media (min-width: @sizes[medium]) {
      padding: 0;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
      width: 265px;
      min-height: 265px !important;

      border-radius: 0;
      border-top-left-radius: 12px;
    }
    @media (min-width: @sizes[large]) {
      border-radius: 5px;
    }

    img {
      border-radius: 5px;
      @media (min-width: @sizes[medium]) {
        border-radius: 0;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }
      @media (min-width: @sizes[large]) {
        border-radius: 5px;
      }
      &.no-terms {
        @media (min-width: @sizes[medium]) {
          border-bottom-left-radius: 0px;
        }
        @media (min-width: @sizes[large]) {
          border-radius: 5px;
        }
      }
    }
  }
  .bonus-card-content {
    padding: 0 16px 16px 16px;
    @media (min-width: @sizes[medium]) {
      padding: 20px 0 20px 16px;
      align-items: flex-start;
      width: calc(100% - 265px);
      flex-direction: row;
      min-height: 265px;
    }
    @media (min-width: @sizes[large]) {
      padding: 0 0 0 16px;
    }
    &-top {
      flex-direction: column;
      @media (min-width: @sizes[medium]) {
        align-items: center;
        flex-direction: row;
      }
      @media (min-width: @sizes[large]) {
        margin-bottom: 16px;
        align-items: flex-start;
      }
      .half-column-cont {
        @media (min-width: @sizes[large]) {
          max-width: 450px;
        }
        .bonus-card-rating {
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          p {
            font-weight: 700;
          }
        }
        span {
          font-size: 22px;
          @media (min-width: @sizes[large]) {
            font-size: 28px;
          }
        }
      }
      .play_term_wrapper {
        @media (min-width: @sizes[large]) {
          align-items: flex-end;
        }
        a {
          min-width: 100%;
          @media (min-width: @sizes[medium]) {
            min-width: 150px;
          }
          @media (min-width: @sizes[large]) {
            min-width: 332px;
          }
        }
      }
    }
    &-bottom {
      padding-top: 16px;
      width: 100%;
      @media (min-width: @sizes[medium]) {
        padding-top: 8px;
      }
      @media (min-width: @sizes[large]) {
        padding-top: 16px;
      }
      .span-h6 {
        font-size: 16px;
        margin-bottom: 12px;
        @media (min-width: @sizes[medium]) {
          font-size: 16px;
          margin-bottom: 6px;
        }
        @media (min-width: @sizes[large]) {
          font-size: 16px;
          margin-bottom: 12px;
        }
      }
      .proslist-rev {
        li {
          margin-bottom: 14px;
          @media (min-width: @sizes[medium]) {
            margin-bottom: 1px;
          }
          @media (min-width: @sizes[large]) {
            margin-bottom: 14px;
          }
        }
      }
    }
  }
}

.offset-md-1 {
  @media (min-width: @sizes[medium]) {
    margin-left: 2.33333%;
  }
}

.play_term_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  .terms_tc {
    margin-bottom: 8px;
  }
  .btn-cust {
    margin: 18px 0 !important;
  }
}
.mx-0 {
  margin-left: 0;
  margin-right: 0;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.sticky-review-card {
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  position: fixed;
  color: @white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: top 0.3s ease-out;
  .rating-wrapper-small {
    @media (min-width: @sizes[large]) {
      display: inline-flex;
      height: 24px;
      border-radius: 50px;
      margin-left: 15px;
      padding: 1px 7px;
      .radio-star-total {
        margin-left: 0;
      }
    }
  }
  .sticky-inner {
    background: var(--primary-btn);
    position: absolute;
    bottom: 0;
    width: 100%;
    max-width: 78.125rem;
    padding: 10px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    flex-wrap: wrap;
    @media (min-width: @sizes[medium]) {
      flex-wrap: nowrap;
    }
    @media (min-width: @sizes[large]) {
      background: @white;
      position: relative;
    }
    .md-rating {
      margin-top: 10px;
      display: none;
      @media (min-width: @sizes[medium]) {
        margin-top: 8px;
        margin-left: -12px;
        display: inline-flex;
        height: 18px;
        border-radius: 50px;
        padding: 1px 7px;
        align-items: stretch;
      }
      .radio-stars {
        height: 14px;
        width: 14px;
        img {
          border-radius: 0;
          vertical-align: text-top;
        }
      }
      .radio-star-total {
        font-size: 14px;
        line-height: 15px;
        padding-left: 0;
        display: inline-flex;
        align-items: center;
        span {
          font-size: 14px;
          line-height: 15px;
        }
      }
      @media (min-width: @sizes[large]) {
        display: none;
      }
    }
    .sticky-text {
      font-size: 0.875rem;
      margin-left: 10px;
      margin-right: auto;
      line-height: 0.75rem;
      width: calc(100% - 60px);
      @media (min-width: @sizes[small]) {
        line-height: unset;
      }
      @media (min-width: @sizes[medium]) {
        width: 100%;
        margin-left: 80px;
      }
      .product-name {
        display: flex;
        padding: 0 0 5px 0;
        @media (min-width: @sizes[medium]) {
          display: none;
        }
        .best-rating {
          margin-left: 8px;
        }
      }
      .sticky-title {
        display: none;
        @media (min-width: @sizes[large]) {
          display: flex;
        }
      }
      .bonus-text {
        font-weight: 900;
        font-size: 0.875rem;
        line-height: 14px;
        @media (min-width: @sizes[small]) {
          line-height: 25px;
        }
        a {
          color: @white;
        }
        @media (min-width: @sizes[medium]) {
          font-size: 0.85rem;
        }
        @media (min-width: @sizes[large]) {
          font-size: 1.625rem;
          a {
            color: @lightdark;
          }
        }
      }
      @media (min-width: @sizes[medium]) {
        font-size: 0.85rem;
      }
      @media (min-width: @sizes[large]) {
        margin-left: 0;
      }
      .terms-conditions {
        @media (min-width: @sizes[large]) {
          padding-top: 5px !important;
        }
        // a {
        //   color: @white;
        //   @media (min-width: @sizes[large]) {
        //     color: @lightestp;
        //   }
        // }
      }
    }
    .affliate-logo {
      height: 50px;
      width: 50px;
      min-height: 50px;
      min-width: 50px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.09);
      left: 0px;
      position: relative;
      img {
        border-radius: 12px;
      }
      @media (min-width: @sizes[medium]) {
        top: -25px;
        position: absolute;
      }
      @media (min-width: @sizes[large]) {
        width: 85px;
        min-width: 85px;
        height: 85px;
        min-height: 85px;
        top: 0;
        left: 0;
        position: relative;
        margin-right: 30px;
      }
    }
    .sticky-play-btn-large {
      display: none;
      font-size: 18px;
      line-height: 100%;
      margin: auto 2px !important;
      //color: @white !important;
      @media (min-width: @sizes[large]) {
        display: block;
        background: var(--primary-btn);
        border-color: var(--primary-btn);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn);
        box-shadow: inset 0 -4px 4px var(--primary-btn);
        min-width: 280px;
        font-weight: 900;
      }
      &:hover {
        background: var(--primary-btn-hover);
        border-color: var(--primary-btn-hover);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
        box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
      }
    }
    .sticky-play-btn-medium {
      display: none;
      font-size: 18px;
      line-height: 100%;
      color: #3672f8 !important;
      @media (min-width: @sizes[medium]) {
        display: block;
        background: @white;
        border-color: var(--primary-btn);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn);
        box-shadow: inset 0 -4px 4px var(--primary-btn);
        box-shadow: none;
        margin: 0;
        min-width: 210px;
        height: 34px;
        margin-left: auto;
      }
      @media (min-width: @sizes[large]) {
        display: none;
      }
      &:hover {
        color: @white;
        background: var(--primary-btn-hover);
        border-color: var(--primary-btn-hover);
        -webkit-box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
        box-shadow: inset 0 -4px 4px var(--primary-btn-hover);
      }
    }
    .sticky-play-btn-mobile {
      background: @white;
      color: var(--primary-btn);
      color: #3672f8 !important;
      border-color: var(--primary-btn);
      box-shadow: none;
      margin: 0;
      line-height: 100%;
      font-size: 0.75rem;
      width: 78px;
      height: 34px;
      padding: 10px 20px;
      @media (min-width: @sizes[medium]) {
        display: none;
      }
    }
  }
  @media (min-width: @sizes[large]) {
    top: -110px;
    height: 110px;
    background: @white;
    color: @lightdark;
  }
}

.mr-30 {
  margin-right: 30px !important;
}

.minus {
  &:before {
    content: "-";
    font-size: 1.9rem;
  }
}

.h-100 {
  height: 100%;
}

.w-100 {
  width: 100%;
}

.lang-flag {
  height: 34px !important;
  width: 60px !important;
  object-fit: cover;
}

.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}

figure > img {
  height: 100%;
  width: 100%;
}

.md-rating {
  .radio-star-total {
    color: #000 !important;
    font-size: 10px !important;
    line-height: 10px !important;
    span {
      color: #000 !important;
      font-size: 10px !important;
      line-height: 10px !important;
    }
  }
}

.view-mob {
  .span-h1 {
    font-size: 24px !important;
    line-height: 27px !important;
    @media (min-width: @sizes[small]) {
      font-size: 36px !important;
      line-height: 44px !important;
    }
  }
}

.rv-terms {
  display: block;
}

.desk-terms {
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
  a {
    //color: #9b9b9b !important;
  }
}

.mob-terms {
  display: block;
  font-size: 0.75rem;
  line-height: 13px;
  width: 100%;
  text-align: center;
  padding: 10px 0 0 0;
  @media (min-width: @sizes[small]) {
    display: none;
  }
  .terms-conditions {
    color: @white;
    a {
      color: @white !important;
      text-decoration: underline !important;
    }
  }
  .mob-cas-term {
    color: @white;
  }
}

.div-term {
  position: absolute;
  background-color: #dfe1e3;
  padding: 7px;
  left: 0;
  width: 100%;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  line-height: 20px;
  position: static;
  width: auto;
  margin: 0px -16px -20px;
  text-align: center;
  @media (min-width: @sizes[medium]) {
    padding: 10px 12px;
    text-align: left;
    position: static;
    width: auto;
    margin: 0px -20px -20px;
  }
  @media (min-width: @sizes[large]) {
    padding: 5px 12px;
    position: static;
    width: auto;
    margin: 0px -30px -30px;
  }
  a {
    cursor: pointer;
    color: var(--primary-btn);
    &:hover {
      color: var(--primary-btn);
    }
  }
}

.terms-d {
  position: relative;
}

.stick-img {
  img {
    width: 100%;
  }
}

.desk-bonus {
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
}

.mob-bonus {
  display: block;
  @media (min-width: @sizes[small]) {
    display: none;
  }
}

.overall-rating {
  background: @white;
  border: 1px solid #f3f2f5;
  box-shadow: 0 0px 20px 0px rgba(0, 0, 0, 0.05);
  .border-radius(12px);
  .rating-header {
    background: #f7f7f7;
    .border-radius(12px 12px 0px 0px);
    padding: 5px 10px 4px 16px;
    .display-flex();
    .align-items(center);
    .justify-content-space-between();
    @media (min-width: @sizes[large]) {
      padding: 7px 30px 6px 26px;
    }
    .span-h2 {
      font-weight: bold;
      color: #020100;
      margin: 0;
      font-size: 20px;
      @media (min-width: @sizes[small]) {
        font-size: 22px;
      }
    }
    .rating-count {
      min-width: 65px;
      min-height: 43px;
      .border-radius(7.75px);
      position: relative;
      .comment {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        .border-radius(0 0 7.75px 7.75px);
        font-style: italic;
        font-weight: normal;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        letter-spacing: -0.03em;
        color: @white;
        padding: 1px 5px;
        display: block;
        box-shadow: 0 0 40px rgba(0, 0, 0, 0.2) inset;
      }
      &-top {
        .display-flex();
        .align-items(center);
        .justify-content-center();
        .value {
          font-weight: bold;
          font-size: 18px;
          line-height: 27px;
          text-align: center;
          letter-spacing: -0.03em;
          color: @white;
          margin-top: 2px;
          @media (min-width: @sizes[small]) {
            font-size: 20px;
          }
        }
        .full-star {
          margin-left: 4px;
          width: 14px;
          height: 14px;
          background: #fabf00;
          .border-radius(2px);
          margin-right: 0px;
          position: relative;
          font-style: normal;
          &:after {
            content: " \2605";
            position: absolute;
            top: 50%;
            left: 50%;
            color: #fff;
            font-size: 10px;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
  .progress-bar-block {
    padding: 8px 8px 20px;
    @media (min-width: @sizes[large]) {
      padding: 20px 35px 19px 27px;
    }
    .bar-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        .display-flex();
        .align-items(center);
        .justify-content-space-between();
        margin-bottom: 5px;
        p {
          font-weight: normal;
          color: #222222;
          margin: 0;
          font-size: 14px;
          overflow-wrap: anywhere;
          margin-right: 10px;
          @media (min-width: @sizes[large]) {
            font-size: 16px;
          }
        }
        span {
          font-weight: bold;
          font-size: 18px;
          line-height: 30px;
          text-align: right;
          text-transform: capitalize;
          color: #222222;
          .display-flex();
          .align-items(center);
          @media (min-width: @sizes[large]) {
            font-size: 20px;
          }
          .full-star {
            margin-left: 8.5px;
            width: 14px;
            height: 14px;
            background: #fabf00;
            .border-radius(2px);
            margin-right: 0px;
            position: relative;
            bottom: 1px;
            font-style: normal;
            &:after {
              content: " \2605";
              position: absolute;
              top: 50%;
              left: 50%;
              color: #fff;
              font-size: 10px;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .bar-rail {
        width: 100%;
        height: 6px;
        background: rgba(206, 205, 205, 0.6);
        .border-radius(52.8455px);
        overflow: hidden;
        .progress-indicator {
          .border-radius(5px);
          height: 6px;
        }
      }
    }
  }
}

.wd-mar {
  width: 100% !important;
  @media (max-width: @sizes[tablet]) {
    margin-left: 0;
  }
}

.cust-span {
  font-size: 24px !important;
  line-height: 27px !important;
  @media (min-width: @sizes[small]) {
    font-size: 32px !important;
    line-height: 40px !important;
  }
}

.ct-btn {
  @media (min-width: @sizes[small]) {
    margin-top: 0px !important;
  }
}

.new-review-banner-card-top-left
  .review-left-content
  .exclusive-bar-title
  .trust
  i
  img {
  width: 8.35px;
}

@media (min-width: @sizes[medium]) {
  .new-review-banner-card-top-left .review-left-content {
    width: calc(100% - 250px);
  }
}

.rev-terms-condition {
  background: #dfe1e3;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 5px 12px;
  line-height: 20px;
  width: 100%;
  text-align: center;
  @media (min-width: @sizes[medium]) {
    text-align: left;
  }
  a {
    cursor: pointer;
    &:hover {
      color: var(--primary-btn);
    }
  }
}

.rm-border {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.exclu-rev {
  border-bottom-left-radius: 0 !important;
  img {
    border-bottom-left-radius: 0 !important;
  }
}

.soft-i {
  margin-right: 0 !important;
}

.pay-i {
  margin-right: 0 !important;
}

.prod-i {
  margin-right: 0 !important;
}

.stripe-sticky {
  display: block !important;
  text-align: center;
  p {
    font-weight: 700;
  }
}

.stripe-sticky {
  position: absolute;
  width: 50px;
  //height: 20px;
  //bottom: 25px;
  top: 50%;
  transform: translateY(6px);
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: @yellow;
  display: none;
  height: 20px;
  line-height: 20px;
  @media (min-width: @sizes[medium]) {
    display: block;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  @media (min-width: @sizes[large]) {
    transform: translateY(25px);
  }
  img {
    width: 14px !important;
    height: 14px !important;
    margin: 3px auto;
    border-radius: 0 !important;
  }
  svg {
    @media (max-width: @sizes[medium]) {
      width: 12px;
    }
  }
}

.desk-excl {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: flex;
  }
  img {
    margin-right: 5px;
  }
}

.mob-excl {
  display: block;
  @media (min-width: @sizes[medium]) {
    display: none;
  }
  @media (max-width: 767px) {
    display: block;
    margin: 0 auto;
  }
}

.desk-ra-excl {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: flex;
  }
}

.mob-ra-excl {
  display: block;
  @media (min-width: @sizes[medium]) {
    display: none;
  }
}

.exclusive-tag-rev {
  //display: block;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 16px;
  font-size: 12px;
  line-height: 15px;
  border-radius: 0 0 5px 5px;
  width: calc(100% - 32px);
  bottom: 10px;
  height: 28px;
  display: flex;
  justify-content: center;
  @media (min-width: @sizes[medium]) {
    //display: none;
    border-radius: 8px;
    margin: auto;
    bottom: 14px;
    width: 90%;
    font-size: 17px;
    line-height: 28px;
    z-index: 10;
  }
  @media (min-width: @sizes[large]) {
    width: 210px;
    bottom: 10px;
  }
  img {
    width: 18px !important;
    height: 18px !important;
    border-radius: 0 !important;
    object-fit: contain !important;
    margin-right: 5px;
    @media (max-width: 767px) {
      //margin: 8px auto;
    }
  }
  p {
    font-weight: bold;
    font-size: 12px;
    margin: 0;
    display: flex;
    align-items: center;
  }
}

.exclu-rev {
  position: relative;
}

.casino {
  &-card {
    ul {
      &.proslist-rev {
        margin: 0;
        padding: 0;
        list-style: none;
        column-count: 0;
        display: block;
        @media (min-width: @sizes[small]) {
          column-count: 2;
          .flex-wrap(wrap);
          .display-flex();
        }
        li {
          width: 100%;
          text-align: left;
          padding-left: 32px;
          line-height: 25px;
          color: @lightdark;
          margin-bottom: 14px;

          background-size: 15px 15px;
          &:last-child {
            margin-bottom: 0px;
          }
          @media (min-width: @sizes[small]) {
            width: 50%;
          }
          &.pros {
            column-count: unset;
            display: block;
            position: relative;
            &:before {
              position: absolute;
              content: "";
              left: 0;
              top: 4px;
              display: inline-block;
              transform: translateY(0px);
              height: 18px;
              width: 18px;
              background: rgba(90, 188, 94, 1) url("~@/assets/images/tick.svg")
                no-repeat;
              border-radius: 100%;
              background-position: center;
              background-size: 10px;
            }
            //background: url("../images/svg-icons/polygon-green.svg") no-repeat 0 1px;
            li {
              width: 100%;
              font-size: 16px;
              line-height: 25px;
              // margin-bottom: 15px;
              margin-bottom: 25px;
              background-position: 0 5px;
              &:last-child {
                margin-bottom: 0px;
              }
            }
          }
          &.cons {
            column-count: unset;
            display: block;
            position: relative;
            //background: url("../images/svg-icons/polygon-orange.svg") no-repeat 0 2px;
            &:before {
              position: absolute;
              content: "";
              left: 0;
              top: 4px;
              display: inline-block;
              transform: translateY(0px);
              height: 18px;
              width: 18px;
              background: rgba(254, 70, 70, 1) url("~@/assets/images/cross.svg")
                no-repeat;
              border-radius: 100%;
              background-position: center;
              background-size: 10px;
            }
            li {
              width: 100%;
              font-size: 16px;
              line-height: 25px;
              // margin-bottom: 15px;
              margin-bottom: 25px;

              background-size: 15px 15px;
              &:last-child {
                margin-bottom: 0px;
              }
            }
          }
        }
      }
    }
  }
}

.p-caption {
  font-weight: 700;
  margin-bottom: 0;
}

.casino-card-lists ul li figure img {
  margin: 0;
}

.developer-card {
  background: @white;
  .border-radius(10px);
  padding: 16px;
  width: 100%;
  max-width: 600px;
  //margin: 0 0 16px;
  .card-header {
    background: #f1f2f3;
    .border-radius(10px);
    padding: 19px 16px;
    .display-flex();
    .align-items(center);
    .justify-content-space-between();
    margin-bottom: 16px;
    flex-wrap: wrap;
    @media (min-width: @sizes[small]) {
      padding: 20px 16px;
    }
    @media (min-width: @sizes[large]) {
      flex-wrap: nowrap;
    }
    .first-head {
      margin-right: 0px;
      @media (min-width: @sizes[large]) {
        margin-right: 8px;
      }
    }
    .second-head {
      margin-top: 8px;
      @media (min-width: @sizes[large]) {
        margin-top: 0px;
      }
    }
    p {
      margin-bottom: 0;
      font-family: Helvetica;
      font-weight: normal;
      font-size: 16px;
      line-height: 1;
      color: #222222;
      strong {
        font-weight: 700;
      }
      i {
        margin-right: 8px;
        img {
          width: 19px;
          margin-bottom: 0px;
        }
      }
    }
  }
  .card-body {
    .withdrl {
      margin-top: 16px;
    }
    .span-h6 {
      font-family: Helvetica;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      color: #222222;
      margin-bottom: 8px;
    }
    ul {
      .display-flex();
      .flex-wrap(wrap);
      .justify-content-flex-start();
      margin: 0 -6px;
      li {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 25px;
        position: relative;
        margin: 0 8px 12px;
        @media (min-width: 375px) {
          margin: 0 9px 12px;
        }
        @media (min-width: 425px) {
          margin: 0 14px 12px;
        }
        @media (min-width: @sizes[small]) {
          margin: 0 6px 8px;
        }
        figure {
          overflow: hidden;
          width: 44px;
          height: 44px;
          background: #f1f2f3;
          .border-radius(5px);
          padding: 0;
          font-weight: bold;
          font-size: 16px;
          line-height: 25px;
          color: #aeaeae;
          .display-flex();
          .align-items(center);
          .justify-content-center();
          img {
            margin: 0;
          }
          @media (min-width: @sizes[small]) {
            width: 60px;
            height: 60px;
          }
        }
      }
    }
    .support-links {
      .display-flex();
      .align-items(flex-start);
      .justify-content-space-between();
      padding: 12px 0 0;
      flex-direction: column;
      @media (min-width: @sizes[large]) {
        .align-items(flex-start);
        flex-direction: column;
      }
      p {
        margin-bottom: 14px;
        font-family: Helvetica;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
        color: #222222;
        margin-right: 0px;
        @media (min-width: @sizes[small]) {
          margin-right: 0px;
          margin-bottom: 18px;
        }
        &:last-child {
          margin-bottom: 0px;
        }
        i {
          top: 2px;
          position: relative;
          margin-right: 8px;
          @media (min-width: @sizes[small]) {
            margin-right: 4px;
          }
        }
      }
    }
  }
  .card-footer {
    border-top: 1px solid #bdbdbe;
    padding: 16px 0 0;
    margin-top: 8px;
    span {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 12px;
      line-height: 14px;
      text-transform: uppercase;
      color: #222222;
      i {
        margin-left: 8px;
        img {
          width: 50px;
          margin-bottom: 0;
        }
      }
    }
  }
}

.casino-card-software-recomend {
  width: 100%;
}

.review-banner-support {
  li {
    margin: 0 auto 0 0 !important;
    @media (min-width: @sizes[small]) {
      margin: 0 16px 0 0 !important;
    }
    &:last-child {
      margin: 0 !important;
    }
    figure {
      width: 44px;
      height: 44px;
      .border-radius(5px);
      @media (min-width: @sizes[small]) {
        width: 60px;
        height: 60px;
      }
    }
  }
}

.span-caption-override {
  font-size: 16px !important;
  font-weight: 700 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Review/Review.vue